//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.3.0.0 (NJsonSchema v11.2.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class Client {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    apiAnnouncementGetAnnouncement(): Observable<AnnouncementVM> {
        let url_ = this.baseUrl + "/api/Announcement/GetAnnouncement";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiAnnouncementGetAnnouncement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiAnnouncementGetAnnouncement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AnnouncementVM>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AnnouncementVM>;
        }));
    }

    protected processApiAnnouncementGetAnnouncement(response: HttpResponseBase): Observable<AnnouncementVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AnnouncementVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiAnnouncementPostAnnouncement(announcement: AnnouncementVM): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Announcement/PostAnnouncement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(announcement);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiAnnouncementPostAnnouncement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiAnnouncementPostAnnouncement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processApiAnnouncementPostAnnouncement(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiBackgroundJobRecurring(): Observable<RegistrationRecurringJobDto[]> {
        let url_ = this.baseUrl + "/api/BackgroundJob/Recurring";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiBackgroundJobRecurring(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiBackgroundJobRecurring(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegistrationRecurringJobDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegistrationRecurringJobDto[]>;
        }));
    }

    protected processApiBackgroundJobRecurring(response: HttpResponseBase): Observable<RegistrationRecurringJobDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RegistrationRecurringJobDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiBackgroundJobTrigger(jobId?: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/BackgroundJob/Trigger?";
        if (jobId !== undefined && jobId !== null)
            url_ += "jobId=" + encodeURIComponent("" + jobId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiBackgroundJobTrigger(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiBackgroundJobTrigger(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processApiBackgroundJobTrigger(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiBackgroundJobAll(): Observable<BackgroundJobDto[]> {
        let url_ = this.baseUrl + "/api/BackgroundJob/All";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiBackgroundJobAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiBackgroundJobAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BackgroundJobDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BackgroundJobDto[]>;
        }));
    }

    protected processApiBackgroundJobAll(response: HttpResponseBase): Observable<BackgroundJobDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BackgroundJobDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiBackgroundJobById(jobId?: string | null | undefined): Observable<BackgroundJobDto> {
        let url_ = this.baseUrl + "/api/BackgroundJob/ById?";
        if (jobId !== undefined && jobId !== null)
            url_ += "jobId=" + encodeURIComponent("" + jobId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiBackgroundJobById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiBackgroundJobById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BackgroundJobDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BackgroundJobDto>;
        }));
    }

    protected processApiBackgroundJobById(response: HttpResponseBase): Observable<BackgroundJobDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BackgroundJobDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiConfigurationGetByTermCode(termCode?: number | undefined): Observable<ConfigurationVM> {
        let url_ = this.baseUrl + "/api/Configuration/GetByTermCode?";
        if (termCode === null)
            throw new Error("The parameter 'termCode' cannot be null.");
        else if (termCode !== undefined)
            url_ += "termCode=" + encodeURIComponent("" + termCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiConfigurationGetByTermCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiConfigurationGetByTermCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConfigurationVM>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConfigurationVM>;
        }));
    }

    protected processApiConfigurationGetByTermCode(response: HttpResponseBase): Observable<ConfigurationVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConfigurationVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiConfigurationAddSchoolOrProgram(model: ConfigurationAddSchoolOrProgramVM): Observable<ConfigurationVM> {
        let url_ = this.baseUrl + "/api/Configuration/AddSchoolOrProgram";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiConfigurationAddSchoolOrProgram(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiConfigurationAddSchoolOrProgram(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConfigurationVM>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConfigurationVM>;
        }));
    }

    protected processApiConfigurationAddSchoolOrProgram(response: HttpResponseBase): Observable<ConfigurationVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConfigurationVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiConfigurationEditProgram(model: ConfigurationEditProgramVM): Observable<ConfigurationVM> {
        let url_ = this.baseUrl + "/api/Configuration/EditProgram";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiConfigurationEditProgram(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiConfigurationEditProgram(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConfigurationVM>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConfigurationVM>;
        }));
    }

    protected processApiConfigurationEditProgram(response: HttpResponseBase): Observable<ConfigurationVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConfigurationVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiConfigurationAddGe(model: ConfigurationAddGeVM): Observable<ConfigurationVM> {
        let url_ = this.baseUrl + "/api/Configuration/AddGe";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiConfigurationAddGe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiConfigurationAddGe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConfigurationVM>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConfigurationVM>;
        }));
    }

    protected processApiConfigurationAddGe(response: HttpResponseBase): Observable<ConfigurationVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConfigurationVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiConfigurationEditGe(model: ConfigurationEditGeVM): Observable<ConfigurationVM> {
        let url_ = this.baseUrl + "/api/Configuration/EditGe";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiConfigurationEditGe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiConfigurationEditGe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConfigurationVM>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConfigurationVM>;
        }));
    }

    protected processApiConfigurationEditGe(response: HttpResponseBase): Observable<ConfigurationVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConfigurationVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiConfigurationDeleteSchool(model: ConfigurationDeleteSchoolVM): Observable<ConfigurationVM> {
        let url_ = this.baseUrl + "/api/Configuration/DeleteSchool";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiConfigurationDeleteSchool(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiConfigurationDeleteSchool(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConfigurationVM>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConfigurationVM>;
        }));
    }

    protected processApiConfigurationDeleteSchool(response: HttpResponseBase): Observable<ConfigurationVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConfigurationVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiConfigurationDeleteProgram(model: ConfigurationDeleteProgramVM): Observable<ConfigurationVM> {
        let url_ = this.baseUrl + "/api/Configuration/DeleteProgram";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiConfigurationDeleteProgram(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiConfigurationDeleteProgram(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConfigurationVM>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConfigurationVM>;
        }));
    }

    protected processApiConfigurationDeleteProgram(response: HttpResponseBase): Observable<ConfigurationVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConfigurationVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiConfigurationUpdateSchoolSortOrders(model: ConfigurationVM): Observable<ConfigurationVM> {
        let url_ = this.baseUrl + "/api/Configuration/UpdateSchoolSortOrders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiConfigurationUpdateSchoolSortOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiConfigurationUpdateSchoolSortOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConfigurationVM>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConfigurationVM>;
        }));
    }

    protected processApiConfigurationUpdateSchoolSortOrders(response: HttpResponseBase): Observable<ConfigurationVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConfigurationVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiConfigurationUpdateProgramSortOrders(model: ConfigurationUpdateProgramSortOrdersVM): Observable<ConfigurationVM> {
        let url_ = this.baseUrl + "/api/Configuration/UpdateProgramSortOrders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiConfigurationUpdateProgramSortOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiConfigurationUpdateProgramSortOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConfigurationVM>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConfigurationVM>;
        }));
    }

    protected processApiConfigurationUpdateProgramSortOrders(response: HttpResponseBase): Observable<ConfigurationVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConfigurationVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiConfigurationUpdateGeRequirementSortOrders(model: ConfigurationVM): Observable<ConfigurationVM> {
        let url_ = this.baseUrl + "/api/Configuration/UpdateGeRequirementSortOrders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiConfigurationUpdateGeRequirementSortOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiConfigurationUpdateGeRequirementSortOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConfigurationVM>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConfigurationVM>;
        }));
    }

    protected processApiConfigurationUpdateGeRequirementSortOrders(response: HttpResponseBase): Observable<ConfigurationVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConfigurationVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiConfigurationUpdateGeCategorySortOrders(model: ConfigurationUpdateGeCategorySortOrdersVM): Observable<ConfigurationVM> {
        let url_ = this.baseUrl + "/api/Configuration/UpdateGeCategorySortOrders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiConfigurationUpdateGeCategorySortOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiConfigurationUpdateGeCategorySortOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConfigurationVM>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConfigurationVM>;
        }));
    }

    protected processApiConfigurationUpdateGeCategorySortOrders(response: HttpResponseBase): Observable<ConfigurationVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConfigurationVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiConfigurationDeleteGeRequirement(model: ConfigurationDeleteGeRequirementVM): Observable<ConfigurationVM> {
        let url_ = this.baseUrl + "/api/Configuration/DeleteGeRequirement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiConfigurationDeleteGeRequirement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiConfigurationDeleteGeRequirement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConfigurationVM>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConfigurationVM>;
        }));
    }

    protected processApiConfigurationDeleteGeRequirement(response: HttpResponseBase): Observable<ConfigurationVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConfigurationVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiConfigurationDeleteGeCategory(model: ConfigurationDeleteGeCategoryVM): Observable<ConfigurationVM> {
        let url_ = this.baseUrl + "/api/Configuration/DeleteGeCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiConfigurationDeleteGeCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiConfigurationDeleteGeCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConfigurationVM>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConfigurationVM>;
        }));
    }

    protected processApiConfigurationDeleteGeCategory(response: HttpResponseBase): Observable<ConfigurationVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConfigurationVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiConfigurationImport(term: TermImportVM): Observable<TermImportResultVM> {
        let url_ = this.baseUrl + "/api/Configuration/Import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(term);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiConfigurationImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiConfigurationImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TermImportResultVM>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TermImportResultVM>;
        }));
    }

    protected processApiConfigurationImport(response: HttpResponseBase): Observable<TermImportResultVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TermImportResultVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiConfigurationArchiveImport(model: TermArchiveImportVM[]): Observable<TermArchiveImportResultVM[]> {
        let url_ = this.baseUrl + "/api/Configuration/ArchiveImport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiConfigurationArchiveImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiConfigurationArchiveImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TermArchiveImportResultVM[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TermArchiveImportResultVM[]>;
        }));
    }

    protected processApiConfigurationArchiveImport(response: HttpResponseBase): Observable<TermArchiveImportResultVM[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TermArchiveImportResultVM.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiConfigurationGetGeRequirements(): Observable<GeRequirement[]> {
        let url_ = this.baseUrl + "/api/Configuration/GetGeRequirements";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiConfigurationGetGeRequirements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiConfigurationGetGeRequirements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeRequirement[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeRequirement[]>;
        }));
    }

    protected processApiConfigurationGetGeRequirements(response: HttpResponseBase): Observable<GeRequirement[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeRequirement.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiCoursesCourse(termCode?: number | undefined, courseCode?: string | null | undefined): Observable<CourseVM> {
        let url_ = this.baseUrl + "/api/Courses/Course?";
        if (termCode === null)
            throw new Error("The parameter 'termCode' cannot be null.");
        else if (termCode !== undefined)
            url_ += "termCode=" + encodeURIComponent("" + termCode) + "&";
        if (courseCode !== undefined && courseCode !== null)
            url_ += "courseCode=" + encodeURIComponent("" + courseCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiCoursesCourse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiCoursesCourse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CourseVM>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CourseVM>;
        }));
    }

    protected processApiCoursesCourse(response: HttpResponseBase): Observable<CourseVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CourseVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiCoursesCoursesByTermSchoolProgram(termCode?: number | undefined, school?: string | null | undefined, program?: string | null | undefined): Observable<ProgramCoursesVM> {
        let url_ = this.baseUrl + "/api/Courses/CoursesByTermSchoolProgram?";
        if (termCode === null)
            throw new Error("The parameter 'termCode' cannot be null.");
        else if (termCode !== undefined)
            url_ += "termCode=" + encodeURIComponent("" + termCode) + "&";
        if (school !== undefined && school !== null)
            url_ += "school=" + encodeURIComponent("" + school) + "&";
        if (program !== undefined && program !== null)
            url_ += "program=" + encodeURIComponent("" + program) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiCoursesCoursesByTermSchoolProgram(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiCoursesCoursesByTermSchoolProgram(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProgramCoursesVM>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProgramCoursesVM>;
        }));
    }

    protected processApiCoursesCoursesByTermSchoolProgram(response: HttpResponseBase): Observable<ProgramCoursesVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProgramCoursesVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiCoursesGeCoursesByTerm(termCode?: number | undefined, geRequirementPrefix?: string | null | undefined, categoryPrefix?: string | null | undefined): Observable<GeCategoryCoursesVM> {
        let url_ = this.baseUrl + "/api/Courses/GeCoursesByTerm?";
        if (termCode === null)
            throw new Error("The parameter 'termCode' cannot be null.");
        else if (termCode !== undefined)
            url_ += "termCode=" + encodeURIComponent("" + termCode) + "&";
        if (geRequirementPrefix !== undefined && geRequirementPrefix !== null)
            url_ += "geRequirementPrefix=" + encodeURIComponent("" + geRequirementPrefix) + "&";
        if (categoryPrefix !== undefined && categoryPrefix !== null)
            url_ += "categoryPrefix=" + encodeURIComponent("" + categoryPrefix) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiCoursesGeCoursesByTerm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiCoursesGeCoursesByTerm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeCategoryCoursesVM>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeCategoryCoursesVM>;
        }));
    }

    protected processApiCoursesGeCoursesByTerm(response: HttpResponseBase): Observable<GeCategoryCoursesVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeCategoryCoursesVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiCoursesCoursesByPreviewConfig(requirementConfig: ConfigurationCourseDefinition): Observable<ProgramCoursesVM> {
        let url_ = this.baseUrl + "/api/Courses/CoursesByPreviewConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requirementConfig);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiCoursesCoursesByPreviewConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiCoursesCoursesByPreviewConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProgramCoursesVM>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProgramCoursesVM>;
        }));
    }

    protected processApiCoursesCoursesByPreviewConfig(response: HttpResponseBase): Observable<ProgramCoursesVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProgramCoursesVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiGeTermCode(termCode?: number | undefined): Observable<GeVM> {
        let url_ = this.baseUrl + "/api/Ge/TermCode?";
        if (termCode === null)
            throw new Error("The parameter 'termCode' cannot be null.");
        else if (termCode !== undefined)
            url_ += "termCode=" + encodeURIComponent("" + termCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiGeTermCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiGeTermCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeVM>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeVM>;
        }));
    }

    protected processApiGeTermCode(response: HttpResponseBase): Observable<GeVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiGeGeProgramDetails(termCode?: number | undefined, geRequirementPrefix?: string | null | undefined, geCategoryPrefix?: string | null | undefined): Observable<GeCategoryDetailsVM> {
        let url_ = this.baseUrl + "/api/Ge/GeProgramDetails?";
        if (termCode === null)
            throw new Error("The parameter 'termCode' cannot be null.");
        else if (termCode !== undefined)
            url_ += "termCode=" + encodeURIComponent("" + termCode) + "&";
        if (geRequirementPrefix !== undefined && geRequirementPrefix !== null)
            url_ += "geRequirementPrefix=" + encodeURIComponent("" + geRequirementPrefix) + "&";
        if (geCategoryPrefix !== undefined && geCategoryPrefix !== null)
            url_ += "geCategoryPrefix=" + encodeURIComponent("" + geCategoryPrefix) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiGeGeProgramDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiGeGeProgramDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeCategoryDetailsVM>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeCategoryDetailsVM>;
        }));
    }

    protected processApiGeGeProgramDetails(response: HttpResponseBase): Observable<GeCategoryDetailsVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeCategoryDetailsVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiPeTermsAll(): Observable<PeTerm[]> {
        let url_ = this.baseUrl + "/api/Pe/TermsAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiPeTermsAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiPeTermsAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PeTerm[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PeTerm[]>;
        }));
    }

    protected processApiPeTermsAll(response: HttpResponseBase): Observable<PeTerm[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PeTerm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiPeSessionsAll(): Observable<PeSession[]> {
        let url_ = this.baseUrl + "/api/Pe/SessionsAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiPeSessionsAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiPeSessionsAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PeSession[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PeSession[]>;
        }));
    }

    protected processApiPeSessionsAll(response: HttpResponseBase): Observable<PeSession[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PeSession.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiPeSessionByRnrSessionId(rnrSessionId?: number | undefined): Observable<PeSession> {
        let url_ = this.baseUrl + "/api/Pe/SessionByRnrSessionId?";
        if (rnrSessionId === null)
            throw new Error("The parameter 'rnrSessionId' cannot be null.");
        else if (rnrSessionId !== undefined)
            url_ += "rnrSessionId=" + encodeURIComponent("" + rnrSessionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiPeSessionByRnrSessionId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiPeSessionByRnrSessionId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PeSession>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PeSession>;
        }));
    }

    protected processApiPeSessionByRnrSessionId(response: HttpResponseBase): Observable<PeSession> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PeSession.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiPeSchoolsAll(): Observable<SchoolVM[]> {
        let url_ = this.baseUrl + "/api/Pe/SchoolsAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiPeSchoolsAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiPeSchoolsAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SchoolVM[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SchoolVM[]>;
        }));
    }

    protected processApiPeSchoolsAll(response: HttpResponseBase): Observable<SchoolVM[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SchoolVM.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiPeProgramsAll(): Observable<ProgramVM[]> {
        let url_ = this.baseUrl + "/api/Pe/ProgramsAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiPeProgramsAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiPeProgramsAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProgramVM[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProgramVM[]>;
        }));
    }

    protected processApiPeProgramsAll(response: HttpResponseBase): Observable<ProgramVM[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProgramVM.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiPeCoursePrefixesAll(): Observable<CoursePrefixVM[]> {
        let url_ = this.baseUrl + "/api/Pe/CoursePrefixesAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiPeCoursePrefixesAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiPeCoursePrefixesAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoursePrefixVM[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoursePrefixVM[]>;
        }));
    }

    protected processApiPeCoursePrefixesAll(response: HttpResponseBase): Observable<CoursePrefixVM[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CoursePrefixVM.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiPeCoursesAll(pageNumber?: number | undefined, itemsPerPage?: number | undefined): Observable<CourseVM[]> {
        let url_ = this.baseUrl + "/api/Pe/CoursesAll?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (itemsPerPage === null)
            throw new Error("The parameter 'itemsPerPage' cannot be null.");
        else if (itemsPerPage !== undefined)
            url_ += "itemsPerPage=" + encodeURIComponent("" + itemsPerPage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiPeCoursesAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiPeCoursesAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CourseVM[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CourseVM[]>;
        }));
    }

    protected processApiPeCoursesAll(response: HttpResponseBase): Observable<CourseVM[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CourseVM.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiPeCoursesByTerm(termCode?: number | undefined, pageNumber?: number | undefined, itemsPerPage?: number | undefined): Observable<CourseVM[]> {
        let url_ = this.baseUrl + "/api/Pe/CoursesByTerm?";
        if (termCode === null)
            throw new Error("The parameter 'termCode' cannot be null.");
        else if (termCode !== undefined)
            url_ += "termCode=" + encodeURIComponent("" + termCode) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (itemsPerPage === null)
            throw new Error("The parameter 'itemsPerPage' cannot be null.");
        else if (itemsPerPage !== undefined)
            url_ += "itemsPerPage=" + encodeURIComponent("" + itemsPerPage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiPeCoursesByTerm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiPeCoursesByTerm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CourseVM[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CourseVM[]>;
        }));
    }

    protected processApiPeCoursesByTerm(response: HttpResponseBase): Observable<CourseVM[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CourseVM.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiPeCoursesHavePrefixInTerm(prefix?: string | null | undefined, termCode?: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Pe/CoursesHavePrefixInTerm?";
        if (prefix !== undefined && prefix !== null)
            url_ += "prefix=" + encodeURIComponent("" + prefix) + "&";
        if (termCode === null)
            throw new Error("The parameter 'termCode' cannot be null.");
        else if (termCode !== undefined)
            url_ += "termCode=" + encodeURIComponent("" + termCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiPeCoursesHavePrefixInTerm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiPeCoursesHavePrefixInTerm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processApiPeCoursesHavePrefixInTerm(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiPeDoesCourseExist(course?: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Pe/DoesCourseExist?";
        if (course !== undefined && course !== null)
            url_ += "course=" + encodeURIComponent("" + course) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiPeDoesCourseExist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiPeDoesCourseExist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processApiPeDoesCourseExist(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiPeGetConfigurableTermsFromPe(): Observable<PeConfigurableTermVM[]> {
        let url_ = this.baseUrl + "/api/Pe/GetConfigurableTermsFromPe";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiPeGetConfigurableTermsFromPe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiPeGetConfigurableTermsFromPe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PeConfigurableTermVM[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PeConfigurableTermVM[]>;
        }));
    }

    protected processApiPeGetConfigurableTermsFromPe(response: HttpResponseBase): Observable<PeConfigurableTermVM[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PeConfigurableTermVM.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiPeGetConfigurableSessionsByTermCode(termCode?: number | undefined): Observable<PeConfigurableSessionVM[]> {
        let url_ = this.baseUrl + "/api/Pe/GetConfigurableSessionsByTermCode?";
        if (termCode === null)
            throw new Error("The parameter 'termCode' cannot be null.");
        else if (termCode !== undefined)
            url_ += "termCode=" + encodeURIComponent("" + termCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiPeGetConfigurableSessionsByTermCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiPeGetConfigurableSessionsByTermCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PeConfigurableSessionVM[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PeConfigurableSessionVM[]>;
        }));
    }

    protected processApiPeGetConfigurableSessionsByTermCode(response: HttpResponseBase): Observable<PeConfigurableSessionVM[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PeConfigurableSessionVM.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiPePopulateLegacyTermsFromPe(): Observable<PeTerm[]> {
        let url_ = this.baseUrl + "/api/Pe/PopulateLegacyTermsFromPe";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiPePopulateLegacyTermsFromPe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiPePopulateLegacyTermsFromPe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PeTerm[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PeTerm[]>;
        }));
    }

    protected processApiPePopulateLegacyTermsFromPe(response: HttpResponseBase): Observable<PeTerm[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PeTerm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiPeGeCodes(): Observable<GeCodeVm[]> {
        let url_ = this.baseUrl + "/api/Pe/GeCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiPeGeCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiPeGeCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeCodeVm[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeCodeVm[]>;
        }));
    }

    protected processApiPeGeCodes(response: HttpResponseBase): Observable<GeCodeVm[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeCodeVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiPeSectionFees(sectionId?: number | undefined): Observable<SectionFeeVm> {
        let url_ = this.baseUrl + "/api/Pe/SectionFees?";
        if (sectionId === null)
            throw new Error("The parameter 'sectionId' cannot be null.");
        else if (sectionId !== undefined)
            url_ += "sectionId=" + encodeURIComponent("" + sectionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiPeSectionFees(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiPeSectionFees(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SectionFeeVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SectionFeeVm>;
        }));
    }

    protected processApiPeSectionFees(response: HttpResponseBase): Observable<SectionFeeVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SectionFeeVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiProgramsTermCode(termCode?: number | undefined): Observable<ProgramVM[]> {
        let url_ = this.baseUrl + "/api/Programs/TermCode?";
        if (termCode === null)
            throw new Error("The parameter 'termCode' cannot be null.");
        else if (termCode !== undefined)
            url_ += "termCode=" + encodeURIComponent("" + termCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiProgramsTermCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiProgramsTermCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProgramVM[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProgramVM[]>;
        }));
    }

    protected processApiProgramsTermCode(response: HttpResponseBase): Observable<ProgramVM[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProgramVM.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiProgramsPrefix(termCode?: number | undefined, school?: string | null | undefined, program?: string | null | undefined): Observable<ProgramDetailsVM> {
        let url_ = this.baseUrl + "/api/Programs/Prefix?";
        if (termCode === null)
            throw new Error("The parameter 'termCode' cannot be null.");
        else if (termCode !== undefined)
            url_ += "termCode=" + encodeURIComponent("" + termCode) + "&";
        if (school !== undefined && school !== null)
            url_ += "school=" + encodeURIComponent("" + school) + "&";
        if (program !== undefined && program !== null)
            url_ += "program=" + encodeURIComponent("" + program) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiProgramsPrefix(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiProgramsPrefix(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProgramDetailsVM>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProgramDetailsVM>;
        }));
    }

    protected processApiProgramsPrefix(response: HttpResponseBase): Observable<ProgramDetailsVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProgramDetailsVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiProgramsGeCategoryDetails(termCode?: number | undefined, geRequirementPrefix?: string | null | undefined, geCategoryPrefix?: string | null | undefined): Observable<GeCategoryDetailsVM> {
        let url_ = this.baseUrl + "/api/Programs/GeCategoryDetails?";
        if (termCode === null)
            throw new Error("The parameter 'termCode' cannot be null.");
        else if (termCode !== undefined)
            url_ += "termCode=" + encodeURIComponent("" + termCode) + "&";
        if (geRequirementPrefix !== undefined && geRequirementPrefix !== null)
            url_ += "geRequirementPrefix=" + encodeURIComponent("" + geRequirementPrefix) + "&";
        if (geCategoryPrefix !== undefined && geCategoryPrefix !== null)
            url_ += "geCategoryPrefix=" + encodeURIComponent("" + geCategoryPrefix) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiProgramsGeCategoryDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiProgramsGeCategoryDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeCategoryDetailsVM>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeCategoryDetailsVM>;
        }));
    }

    protected processApiProgramsGeCategoryDetails(response: HttpResponseBase): Observable<GeCategoryDetailsVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeCategoryDetailsVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiSchoolsTermCode(termCode?: number | undefined): Observable<SchoolVM[]> {
        let url_ = this.baseUrl + "/api/Schools/TermCode?";
        if (termCode === null)
            throw new Error("The parameter 'termCode' cannot be null.");
        else if (termCode !== undefined)
            url_ += "termCode=" + encodeURIComponent("" + termCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiSchoolsTermCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiSchoolsTermCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SchoolVM[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SchoolVM[]>;
        }));
    }

    protected processApiSchoolsTermCode(response: HttpResponseBase): Observable<SchoolVM[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SchoolVM.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiSearchAutocomplete(termCode?: number | undefined): Observable<SearchResultsVm> {
        let url_ = this.baseUrl + "/api/Search/Autocomplete?";
        if (termCode === null)
            throw new Error("The parameter 'termCode' cannot be null.");
        else if (termCode !== undefined)
            url_ += "termCode=" + encodeURIComponent("" + termCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiSearchAutocomplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiSearchAutocomplete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchResultsVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchResultsVm>;
        }));
    }

    protected processApiSearchAutocomplete(response: HttpResponseBase): Observable<SearchResultsVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchResultsVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiSearchBasic(termCode?: number | undefined, searchTerm?: string | null | undefined): Observable<SearchResultsVm> {
        let url_ = this.baseUrl + "/api/Search/Basic?";
        if (termCode === null)
            throw new Error("The parameter 'termCode' cannot be null.");
        else if (termCode !== undefined)
            url_ += "termCode=" + encodeURIComponent("" + termCode) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiSearchBasic(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiSearchBasic(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchResultsVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchResultsVm>;
        }));
    }

    protected processApiSearchBasic(response: HttpResponseBase): Observable<SearchResultsVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchResultsVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiServerStatusAlive(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/ServerStatus/alive";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiServerStatusAlive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiServerStatusAlive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processApiServerStatusAlive(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiSimpleSyllabusCourses(): Observable<SimpleSyllabusCourseDto[]> {
        let url_ = this.baseUrl + "/api/SimpleSyllabus/Courses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiSimpleSyllabusCourses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiSimpleSyllabusCourses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleSyllabusCourseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleSyllabusCourseDto[]>;
        }));
    }

    protected processApiSimpleSyllabusCourses(response: HttpResponseBase): Observable<SimpleSyllabusCourseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SimpleSyllabusCourseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiSimpleSyllabusSections(): Observable<SimpleSyllabusSectionDto[]> {
        let url_ = this.baseUrl + "/api/SimpleSyllabus/Sections";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiSimpleSyllabusSections(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiSimpleSyllabusSections(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleSyllabusSectionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleSyllabusSectionDto[]>;
        }));
    }

    protected processApiSimpleSyllabusSections(response: HttpResponseBase): Observable<SimpleSyllabusSectionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SimpleSyllabusSectionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiSimpleSyllabusAccounts(): Observable<SimpleSyllabusAccountsDto[]> {
        let url_ = this.baseUrl + "/api/SimpleSyllabus/Accounts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiSimpleSyllabusAccounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiSimpleSyllabusAccounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleSyllabusAccountsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleSyllabusAccountsDto[]>;
        }));
    }

    protected processApiSimpleSyllabusAccounts(response: HttpResponseBase): Observable<SimpleSyllabusAccountsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SimpleSyllabusAccountsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiSimpleSyllabusEnrollments(): Observable<SimpleSyllabusEnrollmentsDto[]> {
        let url_ = this.baseUrl + "/api/SimpleSyllabus/Enrollments";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiSimpleSyllabusEnrollments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiSimpleSyllabusEnrollments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleSyllabusEnrollmentsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleSyllabusEnrollmentsDto[]>;
        }));
    }

    protected processApiSimpleSyllabusEnrollments(response: HttpResponseBase): Observable<SimpleSyllabusEnrollmentsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SimpleSyllabusEnrollmentsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiSimpleSyllabusDepartmentCoordinators(): Observable<SimpleSyllabusDepartmentCoordinatorsDto[]> {
        let url_ = this.baseUrl + "/api/SimpleSyllabus/DepartmentCoordinators";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiSimpleSyllabusDepartmentCoordinators(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiSimpleSyllabusDepartmentCoordinators(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleSyllabusDepartmentCoordinatorsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleSyllabusDepartmentCoordinatorsDto[]>;
        }));
    }

    protected processApiSimpleSyllabusDepartmentCoordinators(response: HttpResponseBase): Observable<SimpleSyllabusDepartmentCoordinatorsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SimpleSyllabusDepartmentCoordinatorsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiTermsAll(): Observable<TermVM[]> {
        let url_ = this.baseUrl + "/api/Terms/All";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiTermsAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiTermsAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TermVM[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TermVM[]>;
        }));
    }

    protected processApiTermsAll(response: HttpResponseBase): Observable<TermVM[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TermVM.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiTermsActive(): Observable<TermVM[]> {
        let url_ = this.baseUrl + "/api/Terms/Active";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiTermsActive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiTermsActive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TermVM[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TermVM[]>;
        }));
    }

    protected processApiTermsActive(response: HttpResponseBase): Observable<TermVM[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TermVM.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiTermsTermCode(termCode?: number | undefined): Observable<TermVM> {
        let url_ = this.baseUrl + "/api/Terms/TermCode?";
        if (termCode === null)
            throw new Error("The parameter 'termCode' cannot be null.");
        else if (termCode !== undefined)
            url_ += "termCode=" + encodeURIComponent("" + termCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiTermsTermCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiTermsTermCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TermVM>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TermVM>;
        }));
    }

    protected processApiTermsTermCode(response: HttpResponseBase): Observable<TermVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TermVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiTermsStatus(status?: string | null | undefined): Observable<TermVM[]> {
        let url_ = this.baseUrl + "/api/Terms/Status?";
        if (status !== undefined && status !== null)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiTermsStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiTermsStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TermVM[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TermVM[]>;
        }));
    }

    protected processApiTermsStatus(response: HttpResponseBase): Observable<TermVM[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TermVM.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiTermsNew(term: TermAddVM): Observable<TermVM> {
        let url_ = this.baseUrl + "/api/Terms/New";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(term);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiTermsNew(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiTermsNew(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TermVM>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TermVM>;
        }));
    }

    protected processApiTermsNew(response: HttpResponseBase): Observable<TermVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TermVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiTermsCreate(term: TermCreateVM): Observable<TermVM> {
        let url_ = this.baseUrl + "/api/Terms/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(term);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiTermsCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiTermsCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TermVM>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TermVM>;
        }));
    }

    protected processApiTermsCreate(response: HttpResponseBase): Observable<TermVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TermVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiTermsEdit(termVm: TermVM): Observable<TermVM> {
        let url_ = this.baseUrl + "/api/Terms/Edit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(termVm);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiTermsEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiTermsEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TermVM>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TermVM>;
        }));
    }

    protected processApiTermsEdit(response: HttpResponseBase): Observable<TermVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TermVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiTermsDelete(termCode?: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Terms/Delete?";
        if (termCode === null)
            throw new Error("The parameter 'termCode' cannot be null.");
        else if (termCode !== undefined)
            url_ += "termCode=" + encodeURIComponent("" + termCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiTermsDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiTermsDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processApiTermsDelete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiUsersUser(): Observable<UserVM> {
        let url_ = this.baseUrl + "/api/Users/User";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiUsersUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiUsersUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserVM>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserVM>;
        }));
    }

    protected processApiUsersUser(response: HttpResponseBase): Observable<UserVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiUsersRole(): Observable<string> {
        let url_ = this.baseUrl + "/api/Users/Role";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiUsersRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiUsersRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processApiUsersRole(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiUsersRoles(): Observable<UserRoleVm[]> {
        let url_ = this.baseUrl + "/api/Users/Roles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiUsersRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiUsersRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserRoleVm[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserRoleVm[]>;
        }));
    }

    protected processApiUsersRoles(response: HttpResponseBase): Observable<UserRoleVm[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserRoleVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiUsersAll(): Observable<UserVM[]> {
        let url_ = this.baseUrl + "/api/Users/All";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiUsersAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiUsersAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserVM[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserVM[]>;
        }));
    }

    protected processApiUsersAll(response: HttpResponseBase): Observable<UserVM[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserVM.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiUsersUserByUscId(uscId?: string | null | undefined): Observable<UserVM> {
        let url_ = this.baseUrl + "/api/Users/UserByUscId?";
        if (uscId !== undefined && uscId !== null)
            url_ += "uscId=" + encodeURIComponent("" + uscId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiUsersUserByUscId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiUsersUserByUscId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserVM>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserVM>;
        }));
    }

    protected processApiUsersUserByUscId(response: HttpResponseBase): Observable<UserVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiUsersAdd(user: UserVM): Observable<UserVM> {
        let url_ = this.baseUrl + "/api/Users/Add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiUsersAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiUsersAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserVM>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserVM>;
        }));
    }

    protected processApiUsersAdd(response: HttpResponseBase): Observable<UserVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    apiUsersDelete(user: UserVM): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Users/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiUsersDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiUsersDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processApiUsersDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class AnnouncementVM implements IAnnouncementVM {
    message?: string | undefined;
    messageType?: string | undefined;

    constructor(data?: IAnnouncementVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.messageType = _data["messageType"];
        }
    }

    static fromJS(data: any): AnnouncementVM {
        data = typeof data === 'object' ? data : {};
        let result = new AnnouncementVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["messageType"] = this.messageType;
        return data;
    }
}

export interface IAnnouncementVM {
    message?: string | undefined;
    messageType?: string | undefined;
}

export abstract class BackgroundJobBaseDto implements IBackgroundJobBaseDto {
    jobId!: string;

    constructor(data?: IBackgroundJobBaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["jobId"];
        }
    }

    static fromJS(data: any): BackgroundJobBaseDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BackgroundJobBaseDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId;
        return data;
    }
}

export interface IBackgroundJobBaseDto {
    jobId: string;
}

export class RegistrationRecurringJobDto extends BackgroundJobBaseDto implements IRegistrationRecurringJobDto {
    cronExpression?: string | undefined;
    lastExecution?: string | undefined;
    nextExecution?: string | undefined;

    constructor(data?: IRegistrationRecurringJobDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.cronExpression = _data["cronExpression"];
            this.lastExecution = _data["lastExecution"];
            this.nextExecution = _data["nextExecution"];
        }
    }

    static override fromJS(data: any): RegistrationRecurringJobDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrationRecurringJobDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cronExpression"] = this.cronExpression;
        data["lastExecution"] = this.lastExecution;
        data["nextExecution"] = this.nextExecution;
        super.toJSON(data);
        return data;
    }
}

export interface IRegistrationRecurringJobDto extends IBackgroundJobBaseDto {
    cronExpression?: string | undefined;
    lastExecution?: string | undefined;
    nextExecution?: string | undefined;
}

export class BackgroundJobDto extends BackgroundJobBaseDto implements IBackgroundJobDto {
    state?: string | undefined;
    jobName?: string | undefined;
    scheduledAt?: Date | undefined;

    constructor(data?: IBackgroundJobDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.state = _data["state"];
            this.jobName = _data["jobName"];
            this.scheduledAt = _data["scheduledAt"] ? new Date(_data["scheduledAt"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): BackgroundJobDto {
        data = typeof data === 'object' ? data : {};
        let result = new BackgroundJobDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["jobName"] = this.jobName;
        data["scheduledAt"] = this.scheduledAt ? this.scheduledAt.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IBackgroundJobDto extends IBackgroundJobBaseDto {
    state?: string | undefined;
    jobName?: string | undefined;
    scheduledAt?: Date | undefined;
}

export class BaseModel implements IBaseModel {
    dateCreated?: Date;
    dateModified?: Date | undefined;

    constructor(data?: IBaseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : <any>undefined;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseModel {
        data = typeof data === 'object' ? data : {};
        let result = new BaseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBaseModel {
    dateCreated?: Date;
    dateModified?: Date | undefined;
}

export class ConfigurationVM extends BaseModel implements IConfigurationVM {
    id!: number;
    termCode!: number;
    schoolsConfig?: ConfigurationSchool[] | undefined;
    geGroupsConfig?: ConfigurationGeGroupVM[] | undefined;
    term?: TermVM | undefined;

    constructor(data?: IConfigurationVM) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.termCode = _data["termCode"];
            if (Array.isArray(_data["schoolsConfig"])) {
                this.schoolsConfig = [] as any;
                for (let item of _data["schoolsConfig"])
                    this.schoolsConfig!.push(ConfigurationSchool.fromJS(item));
            }
            if (Array.isArray(_data["geGroupsConfig"])) {
                this.geGroupsConfig = [] as any;
                for (let item of _data["geGroupsConfig"])
                    this.geGroupsConfig!.push(ConfigurationGeGroupVM.fromJS(item));
            }
            this.term = _data["term"] ? TermVM.fromJS(_data["term"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): ConfigurationVM {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationVM();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["termCode"] = this.termCode;
        if (Array.isArray(this.schoolsConfig)) {
            data["schoolsConfig"] = [];
            for (let item of this.schoolsConfig)
                data["schoolsConfig"].push(item.toJSON());
        }
        if (Array.isArray(this.geGroupsConfig)) {
            data["geGroupsConfig"] = [];
            for (let item of this.geGroupsConfig)
                data["geGroupsConfig"].push(item.toJSON());
        }
        data["term"] = this.term ? this.term.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IConfigurationVM extends IBaseModel {
    id: number;
    termCode: number;
    schoolsConfig?: ConfigurationSchool[] | undefined;
    geGroupsConfig?: ConfigurationGeGroupVM[] | undefined;
    term?: TermVM | undefined;
}

export class ConfigurationSchool extends BaseModel implements IConfigurationSchool {
    id?: number;
    configurationId!: number;
    prefix?: string | undefined;
    sortOrder?: number;
    programsConfig?: ConfigurationProgram[] | undefined;

    constructor(data?: IConfigurationSchool) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.configurationId = _data["configurationId"];
            this.prefix = _data["prefix"];
            this.sortOrder = _data["sortOrder"];
            if (Array.isArray(_data["programsConfig"])) {
                this.programsConfig = [] as any;
                for (let item of _data["programsConfig"])
                    this.programsConfig!.push(ConfigurationProgram.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ConfigurationSchool {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationSchool();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["configurationId"] = this.configurationId;
        data["prefix"] = this.prefix;
        data["sortOrder"] = this.sortOrder;
        if (Array.isArray(this.programsConfig)) {
            data["programsConfig"] = [];
            for (let item of this.programsConfig)
                data["programsConfig"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IConfigurationSchool extends IBaseModel {
    id?: number;
    configurationId: number;
    prefix?: string | undefined;
    sortOrder?: number;
    programsConfig?: ConfigurationProgram[] | undefined;
}

export class ConfigurationProgram extends BaseModel implements IConfigurationProgram {
    id?: number;
    schoolConfigurationId!: number;
    prefix?: string | undefined;
    sortOrder?: number;
    prefixesConfig?: ConfigurationPrefix[] | undefined;
    coursesConfig?: ConfigurationCourse[] | undefined;

    constructor(data?: IConfigurationProgram) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.schoolConfigurationId = _data["schoolConfigurationId"];
            this.prefix = _data["prefix"];
            this.sortOrder = _data["sortOrder"];
            if (Array.isArray(_data["prefixesConfig"])) {
                this.prefixesConfig = [] as any;
                for (let item of _data["prefixesConfig"])
                    this.prefixesConfig!.push(ConfigurationPrefix.fromJS(item));
            }
            if (Array.isArray(_data["coursesConfig"])) {
                this.coursesConfig = [] as any;
                for (let item of _data["coursesConfig"])
                    this.coursesConfig!.push(ConfigurationCourse.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ConfigurationProgram {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationProgram();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["schoolConfigurationId"] = this.schoolConfigurationId;
        data["prefix"] = this.prefix;
        data["sortOrder"] = this.sortOrder;
        if (Array.isArray(this.prefixesConfig)) {
            data["prefixesConfig"] = [];
            for (let item of this.prefixesConfig)
                data["prefixesConfig"].push(item.toJSON());
        }
        if (Array.isArray(this.coursesConfig)) {
            data["coursesConfig"] = [];
            for (let item of this.coursesConfig)
                data["coursesConfig"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IConfigurationProgram extends IBaseModel {
    id?: number;
    schoolConfigurationId: number;
    prefix?: string | undefined;
    sortOrder?: number;
    prefixesConfig?: ConfigurationPrefix[] | undefined;
    coursesConfig?: ConfigurationCourse[] | undefined;
}

export class ConfigurationPrefixBase extends BaseModel implements IConfigurationPrefixBase {
    prefix?: string | undefined;
    anyPrefixSelected?: boolean;
    sessionId?: string | undefined;
    anySessionSelected?: boolean;

    constructor(data?: IConfigurationPrefixBase) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.prefix = _data["prefix"];
            this.anyPrefixSelected = _data["anyPrefixSelected"];
            this.sessionId = _data["sessionId"];
            this.anySessionSelected = _data["anySessionSelected"];
        }
    }

    static override fromJS(data: any): ConfigurationPrefixBase {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationPrefixBase();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prefix"] = this.prefix;
        data["anyPrefixSelected"] = this.anyPrefixSelected;
        data["sessionId"] = this.sessionId;
        data["anySessionSelected"] = this.anySessionSelected;
        super.toJSON(data);
        return data;
    }
}

export interface IConfigurationPrefixBase extends IBaseModel {
    prefix?: string | undefined;
    anyPrefixSelected?: boolean;
    sessionId?: string | undefined;
    anySessionSelected?: boolean;
}

export class ConfigurationPrefix extends ConfigurationPrefixBase implements IConfigurationPrefix {
    id?: number;
    programConfigurationId!: number;

    constructor(data?: IConfigurationPrefix) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.programConfigurationId = _data["programConfigurationId"];
        }
    }

    static override fromJS(data: any): ConfigurationPrefix {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationPrefix();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["programConfigurationId"] = this.programConfigurationId;
        super.toJSON(data);
        return data;
    }
}

export interface IConfigurationPrefix extends IConfigurationPrefixBase {
    id?: number;
    programConfigurationId: number;
}

export class ConfigurationCourseBase extends BaseModel implements IConfigurationCourseBase {
    prefix?: string | undefined;
    classNumber?: number;
    sequence?: string | undefined;

    constructor(data?: IConfigurationCourseBase) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.prefix = _data["prefix"];
            this.classNumber = _data["classNumber"];
            this.sequence = _data["sequence"];
        }
    }

    static override fromJS(data: any): ConfigurationCourseBase {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationCourseBase();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prefix"] = this.prefix;
        data["classNumber"] = this.classNumber;
        data["sequence"] = this.sequence;
        super.toJSON(data);
        return data;
    }
}

export interface IConfigurationCourseBase extends IBaseModel {
    prefix?: string | undefined;
    classNumber?: number;
    sequence?: string | undefined;
}

export class ConfigurationCourse extends ConfigurationCourseBase implements IConfigurationCourse {
    id?: number;
    programConfigurationId!: number;

    constructor(data?: IConfigurationCourse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.programConfigurationId = _data["programConfigurationId"];
        }
    }

    static override fromJS(data: any): ConfigurationCourse {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationCourse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["programConfigurationId"] = this.programConfigurationId;
        super.toJSON(data);
        return data;
    }
}

export interface IConfigurationCourse extends IConfigurationCourseBase {
    id?: number;
    programConfigurationId: number;
}

export class ConfigurationGeGroupVM implements IConfigurationGeGroupVM {
    groupType?: GeGroupType;
    geRequirementsConfig?: ConfigurationGeRequirement[] | undefined;

    constructor(data?: IConfigurationGeGroupVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupType = _data["groupType"];
            if (Array.isArray(_data["geRequirementsConfig"])) {
                this.geRequirementsConfig = [] as any;
                for (let item of _data["geRequirementsConfig"])
                    this.geRequirementsConfig!.push(ConfigurationGeRequirement.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConfigurationGeGroupVM {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationGeGroupVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupType"] = this.groupType;
        if (Array.isArray(this.geRequirementsConfig)) {
            data["geRequirementsConfig"] = [];
            for (let item of this.geRequirementsConfig)
                data["geRequirementsConfig"].push(item.toJSON());
        }
        return data;
    }
}

export interface IConfigurationGeGroupVM {
    groupType?: GeGroupType;
    geRequirementsConfig?: ConfigurationGeRequirement[] | undefined;
}

export enum GeGroupType {
    BeforeFall2015 = "BeforeFall2015",
    Fall2015OrLater = "Fall2015OrLater",
}

export class ConfigurationGeRequirement extends BaseModel implements IConfigurationGeRequirement {
    id?: number;
    configurationId!: number;
    geRequirementId!: number;
    sortOrder?: number;
    geCategoriesConfig?: ConfigurationGeCategory[] | undefined;
    geRequirement?: GeRequirement | undefined;

    constructor(data?: IConfigurationGeRequirement) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.configurationId = _data["configurationId"];
            this.geRequirementId = _data["geRequirementId"];
            this.sortOrder = _data["sortOrder"];
            if (Array.isArray(_data["geCategoriesConfig"])) {
                this.geCategoriesConfig = [] as any;
                for (let item of _data["geCategoriesConfig"])
                    this.geCategoriesConfig!.push(ConfigurationGeCategory.fromJS(item));
            }
            this.geRequirement = _data["geRequirement"] ? GeRequirement.fromJS(_data["geRequirement"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): ConfigurationGeRequirement {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationGeRequirement();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["configurationId"] = this.configurationId;
        data["geRequirementId"] = this.geRequirementId;
        data["sortOrder"] = this.sortOrder;
        if (Array.isArray(this.geCategoriesConfig)) {
            data["geCategoriesConfig"] = [];
            for (let item of this.geCategoriesConfig)
                data["geCategoriesConfig"].push(item.toJSON());
        }
        data["geRequirement"] = this.geRequirement ? this.geRequirement.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IConfigurationGeRequirement extends IBaseModel {
    id?: number;
    configurationId: number;
    geRequirementId: number;
    sortOrder?: number;
    geCategoriesConfig?: ConfigurationGeCategory[] | undefined;
    geRequirement?: GeRequirement | undefined;
}

export class ConfigurationGeCategory extends BaseModel implements IConfigurationGeCategory {
    id?: number;
    geRequirementConfigurationId!: number;
    prefix?: string | undefined;
    sortOrder?: number;
    prefixesConfig?: ConfigurationPrefixGe[] | undefined;
    coursesConfig?: ConfigurationCourseGe[] | undefined;

    constructor(data?: IConfigurationGeCategory) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.geRequirementConfigurationId = _data["geRequirementConfigurationId"];
            this.prefix = _data["prefix"];
            this.sortOrder = _data["sortOrder"];
            if (Array.isArray(_data["prefixesConfig"])) {
                this.prefixesConfig = [] as any;
                for (let item of _data["prefixesConfig"])
                    this.prefixesConfig!.push(ConfigurationPrefixGe.fromJS(item));
            }
            if (Array.isArray(_data["coursesConfig"])) {
                this.coursesConfig = [] as any;
                for (let item of _data["coursesConfig"])
                    this.coursesConfig!.push(ConfigurationCourseGe.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ConfigurationGeCategory {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationGeCategory();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["geRequirementConfigurationId"] = this.geRequirementConfigurationId;
        data["prefix"] = this.prefix;
        data["sortOrder"] = this.sortOrder;
        if (Array.isArray(this.prefixesConfig)) {
            data["prefixesConfig"] = [];
            for (let item of this.prefixesConfig)
                data["prefixesConfig"].push(item.toJSON());
        }
        if (Array.isArray(this.coursesConfig)) {
            data["coursesConfig"] = [];
            for (let item of this.coursesConfig)
                data["coursesConfig"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IConfigurationGeCategory extends IBaseModel {
    id?: number;
    geRequirementConfigurationId: number;
    prefix?: string | undefined;
    sortOrder?: number;
    prefixesConfig?: ConfigurationPrefixGe[] | undefined;
    coursesConfig?: ConfigurationCourseGe[] | undefined;
}

export class ConfigurationPrefixGe extends ConfigurationPrefixBase implements IConfigurationPrefixGe {
    id?: number;
    geCategoryConfigurationId!: number;
    geCode?: string | undefined;
    anyGeCodeSelected?: boolean;

    constructor(data?: IConfigurationPrefixGe) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.geCategoryConfigurationId = _data["geCategoryConfigurationId"];
            this.geCode = _data["geCode"];
            this.anyGeCodeSelected = _data["anyGeCodeSelected"];
        }
    }

    static override fromJS(data: any): ConfigurationPrefixGe {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationPrefixGe();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["geCategoryConfigurationId"] = this.geCategoryConfigurationId;
        data["geCode"] = this.geCode;
        data["anyGeCodeSelected"] = this.anyGeCodeSelected;
        super.toJSON(data);
        return data;
    }
}

export interface IConfigurationPrefixGe extends IConfigurationPrefixBase {
    id?: number;
    geCategoryConfigurationId: number;
    geCode?: string | undefined;
    anyGeCodeSelected?: boolean;
}

export class ConfigurationCourseGe extends ConfigurationCourseBase implements IConfigurationCourseGe {
    id?: number;
    geCategoryConfigurationId!: number;

    constructor(data?: IConfigurationCourseGe) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.geCategoryConfigurationId = _data["geCategoryConfigurationId"];
        }
    }

    static override fromJS(data: any): ConfigurationCourseGe {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationCourseGe();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["geCategoryConfigurationId"] = this.geCategoryConfigurationId;
        super.toJSON(data);
        return data;
    }
}

export interface IConfigurationCourseGe extends IConfigurationCourseBase {
    id?: number;
    geCategoryConfigurationId: number;
}

export class GeRequirement extends BaseModel implements IGeRequirement {
    id?: number;
    prefix?: string | undefined;
    name?: string | undefined;
    geGroupType?: GeGroupType;
    sortOrder?: number;

    constructor(data?: IGeRequirement) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.prefix = _data["prefix"];
            this.name = _data["name"];
            this.geGroupType = _data["geGroupType"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static override fromJS(data: any): GeRequirement {
        data = typeof data === 'object' ? data : {};
        let result = new GeRequirement();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["prefix"] = this.prefix;
        data["name"] = this.name;
        data["geGroupType"] = this.geGroupType;
        data["sortOrder"] = this.sortOrder;
        super.toJSON(data);
        return data;
    }
}

export interface IGeRequirement extends IBaseModel {
    id?: number;
    prefix?: string | undefined;
    name?: string | undefined;
    geGroupType?: GeGroupType;
    sortOrder?: number;
}

export class BaseTermVM implements IBaseTermVM {
    term?: TermCode;
    termCode?: number;
    season?: TermSeason;
    year?: number;

    constructor(data?: IBaseTermVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.term = _data["term"] ? TermCode.fromJS(_data["term"]) : <any>undefined;
            this.termCode = _data["termCode"];
            this.season = _data["season"];
            this.year = _data["year"];
        }
    }

    static fromJS(data: any): BaseTermVM {
        data = typeof data === 'object' ? data : {};
        let result = new BaseTermVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["term"] = this.term ? this.term.toJSON() : <any>undefined;
        data["termCode"] = this.termCode;
        data["season"] = this.season;
        data["year"] = this.year;
        return data;
    }
}

export interface IBaseTermVM {
    term?: TermCode;
    termCode?: number;
    season?: TermSeason;
    year?: number;
}

export class TermVM extends BaseTermVM implements ITermVM {
    seasonName!: string;
    status?: TermStatus;
    dateActive?: Date | undefined;
    dateCreated?: Date | undefined;
    dateModified?: Date | undefined;
    createdByUser?: UserVM | undefined;
    updatedByUser?: UserVM | undefined;

    constructor(data?: ITermVM) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.seasonName = _data["seasonName"];
            this.status = _data["status"];
            this.dateActive = _data["dateActive"] ? new Date(_data["dateActive"].toString()) : <any>undefined;
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : <any>undefined;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
            this.createdByUser = _data["createdByUser"] ? UserVM.fromJS(_data["createdByUser"]) : <any>undefined;
            this.updatedByUser = _data["updatedByUser"] ? UserVM.fromJS(_data["updatedByUser"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): TermVM {
        data = typeof data === 'object' ? data : {};
        let result = new TermVM();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seasonName"] = this.seasonName;
        data["status"] = this.status;
        data["dateActive"] = this.dateActive ? this.dateActive.toISOString() : <any>undefined;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        data["createdByUser"] = this.createdByUser ? this.createdByUser.toJSON() : <any>undefined;
        data["updatedByUser"] = this.updatedByUser ? this.updatedByUser.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ITermVM extends IBaseTermVM {
    seasonName: string;
    status?: TermStatus;
    dateActive?: Date | undefined;
    dateCreated?: Date | undefined;
    dateModified?: Date | undefined;
    createdByUser?: UserVM | undefined;
    updatedByUser?: UserVM | undefined;
}

export enum TermStatus {
    Unknown = "Unknown",
    Draft = "Draft",
    Active = "Active",
    Archived = "Archived",
}

export class UserVM implements IUserVM {
    id?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    uscId?: string | undefined;
    role?: UserRoleVm | undefined;
    isDeleted?: boolean;

    constructor(data?: IUserVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.uscId = _data["uscId"];
            this.role = _data["role"] ? UserRoleVm.fromJS(_data["role"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): UserVM {
        data = typeof data === 'object' ? data : {};
        let result = new UserVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["uscId"] = this.uscId;
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IUserVM {
    id?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    uscId?: string | undefined;
    role?: UserRoleVm | undefined;
    isDeleted?: boolean;
}

export class UserRoleVm implements IUserRoleVm {
    roleName?: string | undefined;
    application?: string | undefined;
    roleLevel?: number;

    constructor(data?: IUserRoleVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleName = _data["roleName"];
            this.application = _data["application"];
            this.roleLevel = _data["roleLevel"];
        }
    }

    static fromJS(data: any): UserRoleVm {
        data = typeof data === 'object' ? data : {};
        let result = new UserRoleVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleName"] = this.roleName;
        data["application"] = this.application;
        data["roleLevel"] = this.roleLevel;
        return data;
    }
}

export interface IUserRoleVm {
    roleName?: string | undefined;
    application?: string | undefined;
    roleLevel?: number;
}

export class TermCode implements ITermCode {
    value?: number;
    year?: number;
    term?: number;
    season?: TermSeason;

    constructor(data?: ITermCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.year = _data["year"];
            this.term = _data["term"];
            this.season = _data["season"];
        }
    }

    static fromJS(data: any): TermCode {
        data = typeof data === 'object' ? data : {};
        let result = new TermCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["year"] = this.year;
        data["term"] = this.term;
        data["season"] = this.season;
        return data;
    }
}

export interface ITermCode {
    value?: number;
    year?: number;
    term?: number;
    season?: TermSeason;
}

export enum TermSeason {
    Spring = "Spring",
    Summer = "Summer",
    Fall = "Fall",
}

export class ConfigurationAddSchoolOrProgramVM implements IConfigurationAddSchoolOrProgramVM {
    termCode!: number;
    operationType?: ConfigurationAddType;
    newSchoolPrefix?: string | undefined;
    newProgramPrefix?: string | undefined;
    prefixes?: ConfigurationPrefixAddVM[] | undefined;
    courses?: ConfigurationCourseAddVM[] | undefined;

    constructor(data?: IConfigurationAddSchoolOrProgramVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.termCode = _data["termCode"];
            this.operationType = _data["operationType"];
            this.newSchoolPrefix = _data["newSchoolPrefix"];
            this.newProgramPrefix = _data["newProgramPrefix"];
            if (Array.isArray(_data["prefixes"])) {
                this.prefixes = [] as any;
                for (let item of _data["prefixes"])
                    this.prefixes!.push(ConfigurationPrefixAddVM.fromJS(item));
            }
            if (Array.isArray(_data["courses"])) {
                this.courses = [] as any;
                for (let item of _data["courses"])
                    this.courses!.push(ConfigurationCourseAddVM.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConfigurationAddSchoolOrProgramVM {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationAddSchoolOrProgramVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termCode"] = this.termCode;
        data["operationType"] = this.operationType;
        data["newSchoolPrefix"] = this.newSchoolPrefix;
        data["newProgramPrefix"] = this.newProgramPrefix;
        if (Array.isArray(this.prefixes)) {
            data["prefixes"] = [];
            for (let item of this.prefixes)
                data["prefixes"].push(item.toJSON());
        }
        if (Array.isArray(this.courses)) {
            data["courses"] = [];
            for (let item of this.courses)
                data["courses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IConfigurationAddSchoolOrProgramVM {
    termCode: number;
    operationType?: ConfigurationAddType;
    newSchoolPrefix?: string | undefined;
    newProgramPrefix?: string | undefined;
    prefixes?: ConfigurationPrefixAddVM[] | undefined;
    courses?: ConfigurationCourseAddVM[] | undefined;
}

export enum ConfigurationAddType {
    NewSchool = "NewSchool",
    NewProgramToExistingSchool = "NewProgramToExistingSchool",
}

export class ConfigurationPrefixAddVMBase implements IConfigurationPrefixAddVMBase {
    prefix?: string | undefined;
    anyPrefixSelected?: boolean;
    sessionId?: string | undefined;
    anySessionSelected?: boolean;

    constructor(data?: IConfigurationPrefixAddVMBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prefix = _data["prefix"];
            this.anyPrefixSelected = _data["anyPrefixSelected"];
            this.sessionId = _data["sessionId"];
            this.anySessionSelected = _data["anySessionSelected"];
        }
    }

    static fromJS(data: any): ConfigurationPrefixAddVMBase {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationPrefixAddVMBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prefix"] = this.prefix;
        data["anyPrefixSelected"] = this.anyPrefixSelected;
        data["sessionId"] = this.sessionId;
        data["anySessionSelected"] = this.anySessionSelected;
        return data;
    }
}

export interface IConfigurationPrefixAddVMBase {
    prefix?: string | undefined;
    anyPrefixSelected?: boolean;
    sessionId?: string | undefined;
    anySessionSelected?: boolean;
}

export class ConfigurationPrefixAddVM extends ConfigurationPrefixAddVMBase implements IConfigurationPrefixAddVM {
    programConfigurationId!: number;

    constructor(data?: IConfigurationPrefixAddVM) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.programConfigurationId = _data["programConfigurationId"];
        }
    }

    static override fromJS(data: any): ConfigurationPrefixAddVM {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationPrefixAddVM();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["programConfigurationId"] = this.programConfigurationId;
        super.toJSON(data);
        return data;
    }
}

export interface IConfigurationPrefixAddVM extends IConfigurationPrefixAddVMBase {
    programConfigurationId: number;
}

export class ConfigurationCourseAddVMBase implements IConfigurationCourseAddVMBase {
    prefix?: string | undefined;
    classNumber?: number;
    sequence?: string | undefined;

    constructor(data?: IConfigurationCourseAddVMBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prefix = _data["prefix"];
            this.classNumber = _data["classNumber"];
            this.sequence = _data["sequence"];
        }
    }

    static fromJS(data: any): ConfigurationCourseAddVMBase {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationCourseAddVMBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prefix"] = this.prefix;
        data["classNumber"] = this.classNumber;
        data["sequence"] = this.sequence;
        return data;
    }
}

export interface IConfigurationCourseAddVMBase {
    prefix?: string | undefined;
    classNumber?: number;
    sequence?: string | undefined;
}

export class ConfigurationCourseAddVM extends ConfigurationCourseAddVMBase implements IConfigurationCourseAddVM {
    programConfigurationId!: number;

    constructor(data?: IConfigurationCourseAddVM) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.programConfigurationId = _data["programConfigurationId"];
        }
    }

    static override fromJS(data: any): ConfigurationCourseAddVM {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationCourseAddVM();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["programConfigurationId"] = this.programConfigurationId;
        super.toJSON(data);
        return data;
    }
}

export interface IConfigurationCourseAddVM extends IConfigurationCourseAddVMBase {
    programConfigurationId: number;
}

export class ConfigurationEditProgramVM implements IConfigurationEditProgramVM {
    configurationId!: number;
    programConfigurationId!: number;
    prefixUpdates?: ConfigurationPrefixUpdates | undefined;
    courseUpdates?: ConfigurationCourseUpdates | undefined;

    constructor(data?: IConfigurationEditProgramVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.configurationId = _data["configurationId"];
            this.programConfigurationId = _data["programConfigurationId"];
            this.prefixUpdates = _data["prefixUpdates"] ? ConfigurationPrefixUpdates.fromJS(_data["prefixUpdates"]) : <any>undefined;
            this.courseUpdates = _data["courseUpdates"] ? ConfigurationCourseUpdates.fromJS(_data["courseUpdates"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ConfigurationEditProgramVM {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationEditProgramVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["configurationId"] = this.configurationId;
        data["programConfigurationId"] = this.programConfigurationId;
        data["prefixUpdates"] = this.prefixUpdates ? this.prefixUpdates.toJSON() : <any>undefined;
        data["courseUpdates"] = this.courseUpdates ? this.courseUpdates.toJSON() : <any>undefined;
        return data;
    }
}

export interface IConfigurationEditProgramVM {
    configurationId: number;
    programConfigurationId: number;
    prefixUpdates?: ConfigurationPrefixUpdates | undefined;
    courseUpdates?: ConfigurationCourseUpdates | undefined;
}

export class ConfigurationPrefixUpdatesBase implements IConfigurationPrefixUpdatesBase {
    deleteIds?: number[] | undefined;

    constructor(data?: IConfigurationPrefixUpdatesBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["deleteIds"])) {
                this.deleteIds = [] as any;
                for (let item of _data["deleteIds"])
                    this.deleteIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ConfigurationPrefixUpdatesBase {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationPrefixUpdatesBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.deleteIds)) {
            data["deleteIds"] = [];
            for (let item of this.deleteIds)
                data["deleteIds"].push(item);
        }
        return data;
    }
}

export interface IConfigurationPrefixUpdatesBase {
    deleteIds?: number[] | undefined;
}

export class ConfigurationPrefixUpdates extends ConfigurationPrefixUpdatesBase implements IConfigurationPrefixUpdates {
    adds?: ConfigurationPrefixAddVM[] | undefined;
    updates?: ConfigurationPrefix[] | undefined;

    constructor(data?: IConfigurationPrefixUpdates) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["adds"])) {
                this.adds = [] as any;
                for (let item of _data["adds"])
                    this.adds!.push(ConfigurationPrefixAddVM.fromJS(item));
            }
            if (Array.isArray(_data["updates"])) {
                this.updates = [] as any;
                for (let item of _data["updates"])
                    this.updates!.push(ConfigurationPrefix.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ConfigurationPrefixUpdates {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationPrefixUpdates();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.adds)) {
            data["adds"] = [];
            for (let item of this.adds)
                data["adds"].push(item.toJSON());
        }
        if (Array.isArray(this.updates)) {
            data["updates"] = [];
            for (let item of this.updates)
                data["updates"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IConfigurationPrefixUpdates extends IConfigurationPrefixUpdatesBase {
    adds?: ConfigurationPrefixAddVM[] | undefined;
    updates?: ConfigurationPrefix[] | undefined;
}

export class ConfigurationCourseUpdatesBase implements IConfigurationCourseUpdatesBase {
    deleteIds?: number[] | undefined;

    constructor(data?: IConfigurationCourseUpdatesBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["deleteIds"])) {
                this.deleteIds = [] as any;
                for (let item of _data["deleteIds"])
                    this.deleteIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ConfigurationCourseUpdatesBase {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationCourseUpdatesBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.deleteIds)) {
            data["deleteIds"] = [];
            for (let item of this.deleteIds)
                data["deleteIds"].push(item);
        }
        return data;
    }
}

export interface IConfigurationCourseUpdatesBase {
    deleteIds?: number[] | undefined;
}

export class ConfigurationCourseUpdates extends ConfigurationCourseUpdatesBase implements IConfigurationCourseUpdates {
    adds?: ConfigurationCourseAddVM[] | undefined;
    updates?: ConfigurationCourse[] | undefined;

    constructor(data?: IConfigurationCourseUpdates) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["adds"])) {
                this.adds = [] as any;
                for (let item of _data["adds"])
                    this.adds!.push(ConfigurationCourseAddVM.fromJS(item));
            }
            if (Array.isArray(_data["updates"])) {
                this.updates = [] as any;
                for (let item of _data["updates"])
                    this.updates!.push(ConfigurationCourse.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ConfigurationCourseUpdates {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationCourseUpdates();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.adds)) {
            data["adds"] = [];
            for (let item of this.adds)
                data["adds"].push(item.toJSON());
        }
        if (Array.isArray(this.updates)) {
            data["updates"] = [];
            for (let item of this.updates)
                data["updates"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IConfigurationCourseUpdates extends IConfigurationCourseUpdatesBase {
    adds?: ConfigurationCourseAddVM[] | undefined;
    updates?: ConfigurationCourse[] | undefined;
}

export class ConfigurationAddGeVM implements IConfigurationAddGeVM {
    configurationId!: number;
    geRequirementId!: number;
    categoryPrefix!: string;
    prefixes?: ConfigurationPrefixGeAddVM[] | undefined;
    courses?: ConfigurationCourseGeAddVM[] | undefined;

    constructor(data?: IConfigurationAddGeVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.configurationId = _data["configurationId"];
            this.geRequirementId = _data["geRequirementId"];
            this.categoryPrefix = _data["categoryPrefix"];
            if (Array.isArray(_data["prefixes"])) {
                this.prefixes = [] as any;
                for (let item of _data["prefixes"])
                    this.prefixes!.push(ConfigurationPrefixGeAddVM.fromJS(item));
            }
            if (Array.isArray(_data["courses"])) {
                this.courses = [] as any;
                for (let item of _data["courses"])
                    this.courses!.push(ConfigurationCourseGeAddVM.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConfigurationAddGeVM {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationAddGeVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["configurationId"] = this.configurationId;
        data["geRequirementId"] = this.geRequirementId;
        data["categoryPrefix"] = this.categoryPrefix;
        if (Array.isArray(this.prefixes)) {
            data["prefixes"] = [];
            for (let item of this.prefixes)
                data["prefixes"].push(item.toJSON());
        }
        if (Array.isArray(this.courses)) {
            data["courses"] = [];
            for (let item of this.courses)
                data["courses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IConfigurationAddGeVM {
    configurationId: number;
    geRequirementId: number;
    categoryPrefix: string;
    prefixes?: ConfigurationPrefixGeAddVM[] | undefined;
    courses?: ConfigurationCourseGeAddVM[] | undefined;
}

export class ConfigurationPrefixGeAddVM extends ConfigurationPrefixAddVMBase implements IConfigurationPrefixGeAddVM {
    geCategoryConfigurationId!: number;
    geCode?: string | undefined;
    anyGeCodeSelected?: boolean;

    constructor(data?: IConfigurationPrefixGeAddVM) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.geCategoryConfigurationId = _data["geCategoryConfigurationId"];
            this.geCode = _data["geCode"];
            this.anyGeCodeSelected = _data["anyGeCodeSelected"];
        }
    }

    static override fromJS(data: any): ConfigurationPrefixGeAddVM {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationPrefixGeAddVM();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["geCategoryConfigurationId"] = this.geCategoryConfigurationId;
        data["geCode"] = this.geCode;
        data["anyGeCodeSelected"] = this.anyGeCodeSelected;
        super.toJSON(data);
        return data;
    }
}

export interface IConfigurationPrefixGeAddVM extends IConfigurationPrefixAddVMBase {
    geCategoryConfigurationId: number;
    geCode?: string | undefined;
    anyGeCodeSelected?: boolean;
}

export class ConfigurationCourseGeAddVM extends ConfigurationCourseAddVMBase implements IConfigurationCourseGeAddVM {
    geCategoryConfigurationId!: number;

    constructor(data?: IConfigurationCourseGeAddVM) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.geCategoryConfigurationId = _data["geCategoryConfigurationId"];
        }
    }

    static override fromJS(data: any): ConfigurationCourseGeAddVM {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationCourseGeAddVM();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["geCategoryConfigurationId"] = this.geCategoryConfigurationId;
        super.toJSON(data);
        return data;
    }
}

export interface IConfigurationCourseGeAddVM extends IConfigurationCourseAddVMBase {
    geCategoryConfigurationId: number;
}

export class ConfigurationEditGeVM implements IConfigurationEditGeVM {
    configurationId!: number;
    geCategoryConfigurationId!: number;
    prefixGeUpdates?: ConfigurationPrefixGeUpdates | undefined;
    courseGeUpdates?: ConfigurationCourseGeUpdates | undefined;

    constructor(data?: IConfigurationEditGeVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.configurationId = _data["configurationId"];
            this.geCategoryConfigurationId = _data["geCategoryConfigurationId"];
            this.prefixGeUpdates = _data["prefixGeUpdates"] ? ConfigurationPrefixGeUpdates.fromJS(_data["prefixGeUpdates"]) : <any>undefined;
            this.courseGeUpdates = _data["courseGeUpdates"] ? ConfigurationCourseGeUpdates.fromJS(_data["courseGeUpdates"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ConfigurationEditGeVM {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationEditGeVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["configurationId"] = this.configurationId;
        data["geCategoryConfigurationId"] = this.geCategoryConfigurationId;
        data["prefixGeUpdates"] = this.prefixGeUpdates ? this.prefixGeUpdates.toJSON() : <any>undefined;
        data["courseGeUpdates"] = this.courseGeUpdates ? this.courseGeUpdates.toJSON() : <any>undefined;
        return data;
    }
}

export interface IConfigurationEditGeVM {
    configurationId: number;
    geCategoryConfigurationId: number;
    prefixGeUpdates?: ConfigurationPrefixGeUpdates | undefined;
    courseGeUpdates?: ConfigurationCourseGeUpdates | undefined;
}

export class ConfigurationPrefixGeUpdates extends ConfigurationPrefixUpdatesBase implements IConfigurationPrefixGeUpdates {
    adds?: ConfigurationPrefixGeAddVM[] | undefined;
    updates?: ConfigurationPrefixGe[] | undefined;

    constructor(data?: IConfigurationPrefixGeUpdates) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["adds"])) {
                this.adds = [] as any;
                for (let item of _data["adds"])
                    this.adds!.push(ConfigurationPrefixGeAddVM.fromJS(item));
            }
            if (Array.isArray(_data["updates"])) {
                this.updates = [] as any;
                for (let item of _data["updates"])
                    this.updates!.push(ConfigurationPrefixGe.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ConfigurationPrefixGeUpdates {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationPrefixGeUpdates();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.adds)) {
            data["adds"] = [];
            for (let item of this.adds)
                data["adds"].push(item.toJSON());
        }
        if (Array.isArray(this.updates)) {
            data["updates"] = [];
            for (let item of this.updates)
                data["updates"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IConfigurationPrefixGeUpdates extends IConfigurationPrefixUpdatesBase {
    adds?: ConfigurationPrefixGeAddVM[] | undefined;
    updates?: ConfigurationPrefixGe[] | undefined;
}

export class ConfigurationCourseGeUpdates extends ConfigurationCourseUpdatesBase implements IConfigurationCourseGeUpdates {
    adds?: ConfigurationCourseGeAddVM[] | undefined;
    updates?: ConfigurationCourseGe[] | undefined;

    constructor(data?: IConfigurationCourseGeUpdates) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["adds"])) {
                this.adds = [] as any;
                for (let item of _data["adds"])
                    this.adds!.push(ConfigurationCourseGeAddVM.fromJS(item));
            }
            if (Array.isArray(_data["updates"])) {
                this.updates = [] as any;
                for (let item of _data["updates"])
                    this.updates!.push(ConfigurationCourseGe.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ConfigurationCourseGeUpdates {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationCourseGeUpdates();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.adds)) {
            data["adds"] = [];
            for (let item of this.adds)
                data["adds"].push(item.toJSON());
        }
        if (Array.isArray(this.updates)) {
            data["updates"] = [];
            for (let item of this.updates)
                data["updates"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IConfigurationCourseGeUpdates extends IConfigurationCourseUpdatesBase {
    adds?: ConfigurationCourseGeAddVM[] | undefined;
    updates?: ConfigurationCourseGe[] | undefined;
}

export class ConfigurationDeleteSchoolVM implements IConfigurationDeleteSchoolVM {
    configurationId!: number;
    schoolId!: number;
    prefix?: string | undefined;

    constructor(data?: IConfigurationDeleteSchoolVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.configurationId = _data["configurationId"];
            this.schoolId = _data["schoolId"];
            this.prefix = _data["prefix"];
        }
    }

    static fromJS(data: any): ConfigurationDeleteSchoolVM {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationDeleteSchoolVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["configurationId"] = this.configurationId;
        data["schoolId"] = this.schoolId;
        data["prefix"] = this.prefix;
        return data;
    }
}

export interface IConfigurationDeleteSchoolVM {
    configurationId: number;
    schoolId: number;
    prefix?: string | undefined;
}

export class ConfigurationDeleteProgramVM implements IConfigurationDeleteProgramVM {
    configurationId!: number;
    programId!: number;
    prefix?: string | undefined;

    constructor(data?: IConfigurationDeleteProgramVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.configurationId = _data["configurationId"];
            this.programId = _data["programId"];
            this.prefix = _data["prefix"];
        }
    }

    static fromJS(data: any): ConfigurationDeleteProgramVM {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationDeleteProgramVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["configurationId"] = this.configurationId;
        data["programId"] = this.programId;
        data["prefix"] = this.prefix;
        return data;
    }
}

export interface IConfigurationDeleteProgramVM {
    configurationId: number;
    programId: number;
    prefix?: string | undefined;
}

export class ConfigurationUpdateProgramSortOrdersVM implements IConfigurationUpdateProgramSortOrdersVM {
    configurationId!: number;
    schoolConfigurationId!: number;
    programsConfig?: ConfigurationProgram[] | undefined;

    constructor(data?: IConfigurationUpdateProgramSortOrdersVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.configurationId = _data["configurationId"];
            this.schoolConfigurationId = _data["schoolConfigurationId"];
            if (Array.isArray(_data["programsConfig"])) {
                this.programsConfig = [] as any;
                for (let item of _data["programsConfig"])
                    this.programsConfig!.push(ConfigurationProgram.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConfigurationUpdateProgramSortOrdersVM {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationUpdateProgramSortOrdersVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["configurationId"] = this.configurationId;
        data["schoolConfigurationId"] = this.schoolConfigurationId;
        if (Array.isArray(this.programsConfig)) {
            data["programsConfig"] = [];
            for (let item of this.programsConfig)
                data["programsConfig"].push(item.toJSON());
        }
        return data;
    }
}

export interface IConfigurationUpdateProgramSortOrdersVM {
    configurationId: number;
    schoolConfigurationId: number;
    programsConfig?: ConfigurationProgram[] | undefined;
}

export class ConfigurationUpdateGeCategorySortOrdersVM implements IConfigurationUpdateGeCategorySortOrdersVM {
    configurationId!: number;
    geRequirementConfigurationId!: number;
    geCategoriesConfig?: ConfigurationGeCategory[] | undefined;

    constructor(data?: IConfigurationUpdateGeCategorySortOrdersVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.configurationId = _data["configurationId"];
            this.geRequirementConfigurationId = _data["geRequirementConfigurationId"];
            if (Array.isArray(_data["geCategoriesConfig"])) {
                this.geCategoriesConfig = [] as any;
                for (let item of _data["geCategoriesConfig"])
                    this.geCategoriesConfig!.push(ConfigurationGeCategory.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConfigurationUpdateGeCategorySortOrdersVM {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationUpdateGeCategorySortOrdersVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["configurationId"] = this.configurationId;
        data["geRequirementConfigurationId"] = this.geRequirementConfigurationId;
        if (Array.isArray(this.geCategoriesConfig)) {
            data["geCategoriesConfig"] = [];
            for (let item of this.geCategoriesConfig)
                data["geCategoriesConfig"].push(item.toJSON());
        }
        return data;
    }
}

export interface IConfigurationUpdateGeCategorySortOrdersVM {
    configurationId: number;
    geRequirementConfigurationId: number;
    geCategoriesConfig?: ConfigurationGeCategory[] | undefined;
}

export class ConfigurationDeleteGeRequirementVM implements IConfigurationDeleteGeRequirementVM {
    configurationId!: number;
    geRequirementId!: number;

    constructor(data?: IConfigurationDeleteGeRequirementVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.configurationId = _data["configurationId"];
            this.geRequirementId = _data["geRequirementId"];
        }
    }

    static fromJS(data: any): ConfigurationDeleteGeRequirementVM {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationDeleteGeRequirementVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["configurationId"] = this.configurationId;
        data["geRequirementId"] = this.geRequirementId;
        return data;
    }
}

export interface IConfigurationDeleteGeRequirementVM {
    configurationId: number;
    geRequirementId: number;
}

export class ConfigurationDeleteGeCategoryVM implements IConfigurationDeleteGeCategoryVM {
    configurationId!: number;
    geCategoryId!: number;

    constructor(data?: IConfigurationDeleteGeCategoryVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.configurationId = _data["configurationId"];
            this.geCategoryId = _data["geCategoryId"];
        }
    }

    static fromJS(data: any): ConfigurationDeleteGeCategoryVM {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationDeleteGeCategoryVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["configurationId"] = this.configurationId;
        data["geCategoryId"] = this.geCategoryId;
        return data;
    }
}

export interface IConfigurationDeleteGeCategoryVM {
    configurationId: number;
    geCategoryId: number;
}

export class TermImportResultVM implements ITermImportResultVM {
    termCode!: number;
    errorMessage?: string | undefined;
    infoMessage?: string | undefined;
    isSuccessful?: boolean;
    term?: TermVM | undefined;

    constructor(data?: ITermImportResultVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.termCode = _data["termCode"];
            this.errorMessage = _data["errorMessage"];
            this.infoMessage = _data["infoMessage"];
            this.isSuccessful = _data["isSuccessful"];
            this.term = _data["term"] ? TermVM.fromJS(_data["term"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TermImportResultVM {
        data = typeof data === 'object' ? data : {};
        let result = new TermImportResultVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termCode"] = this.termCode;
        data["errorMessage"] = this.errorMessage;
        data["infoMessage"] = this.infoMessage;
        data["isSuccessful"] = this.isSuccessful;
        data["term"] = this.term ? this.term.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITermImportResultVM {
    termCode: number;
    errorMessage?: string | undefined;
    infoMessage?: string | undefined;
    isSuccessful?: boolean;
    term?: TermVM | undefined;
}

export class TermImportVM implements ITermImportVM {
    termCode!: number;
    dateActive!: Date;
    configuration!: ConfigurationVM;

    constructor(data?: ITermImportVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.configuration = new ConfigurationVM();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.termCode = _data["termCode"];
            this.dateActive = _data["dateActive"] ? new Date(_data["dateActive"].toString()) : <any>undefined;
            this.configuration = _data["configuration"] ? ConfigurationVM.fromJS(_data["configuration"]) : new ConfigurationVM();
        }
    }

    static fromJS(data: any): TermImportVM {
        data = typeof data === 'object' ? data : {};
        let result = new TermImportVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termCode"] = this.termCode;
        data["dateActive"] = this.dateActive ? this.dateActive.toISOString() : <any>undefined;
        data["configuration"] = this.configuration ? this.configuration.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITermImportVM {
    termCode: number;
    dateActive: Date;
    configuration: ConfigurationVM;
}

export class TermArchiveImportResultVM extends TermImportResultVM implements ITermArchiveImportResultVM {
    fileName!: string;

    constructor(data?: ITermArchiveImportResultVM) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fileName = _data["fileName"];
        }
    }

    static override fromJS(data: any): TermArchiveImportResultVM {
        data = typeof data === 'object' ? data : {};
        let result = new TermArchiveImportResultVM();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        super.toJSON(data);
        return data;
    }
}

export interface ITermArchiveImportResultVM extends ITermImportResultVM {
    fileName: string;
}

export class TermArchiveImportVM implements ITermArchiveImportVM {
    termCode!: number;
    fileName!: string;
    dateActive?: Date | undefined;
    jsonContent!: ArchiveSchoolsContainer;

    constructor(data?: ITermArchiveImportVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.jsonContent = new ArchiveSchoolsContainer();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.termCode = _data["termCode"];
            this.fileName = _data["fileName"];
            this.dateActive = _data["dateActive"] ? new Date(_data["dateActive"].toString()) : <any>undefined;
            this.jsonContent = _data["jsonContent"] ? ArchiveSchoolsContainer.fromJS(_data["jsonContent"]) : new ArchiveSchoolsContainer();
        }
    }

    static fromJS(data: any): TermArchiveImportVM {
        data = typeof data === 'object' ? data : {};
        let result = new TermArchiveImportVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termCode"] = this.termCode;
        data["fileName"] = this.fileName;
        data["dateActive"] = this.dateActive ? this.dateActive.toISOString() : <any>undefined;
        data["jsonContent"] = this.jsonContent ? this.jsonContent.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITermArchiveImportVM {
    termCode: number;
    fileName: string;
    dateActive?: Date | undefined;
    jsonContent: ArchiveSchoolsContainer;
}

export class ArchiveSchoolsContainer implements IArchiveSchoolsContainer {
    schoolsConfig?: { [key: string]: ArchiveProgramConfig[]; } | undefined;

    constructor(data?: IArchiveSchoolsContainer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["schoolsConfig"]) {
                this.schoolsConfig = {} as any;
                for (let key in _data["schoolsConfig"]) {
                    if (_data["schoolsConfig"].hasOwnProperty(key))
                        (<any>this.schoolsConfig)![key] = _data["schoolsConfig"][key] ? _data["schoolsConfig"][key].map((i: any) => ArchiveProgramConfig.fromJS(i)) : [];
                }
            }
        }
    }

    static fromJS(data: any): ArchiveSchoolsContainer {
        data = typeof data === 'object' ? data : {};
        let result = new ArchiveSchoolsContainer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.schoolsConfig) {
            data["schoolsConfig"] = {};
            for (let key in this.schoolsConfig) {
                if (this.schoolsConfig.hasOwnProperty(key))
                    (<any>data["schoolsConfig"])[key] = (<any>this.schoolsConfig)[key];
            }
        }
        return data;
    }
}

export interface IArchiveSchoolsContainer {
    schoolsConfig?: { [key: string]: ArchiveProgramConfig[]; } | undefined;
}

export class ArchiveProgramConfig implements IArchiveProgramConfig {
    name?: string | undefined;
    courses?: string[] | undefined;

    constructor(data?: IArchiveProgramConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["courses"])) {
                this.courses = [] as any;
                for (let item of _data["courses"])
                    this.courses!.push(item);
            }
        }
    }

    static fromJS(data: any): ArchiveProgramConfig {
        data = typeof data === 'object' ? data : {};
        let result = new ArchiveProgramConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.courses)) {
            data["courses"] = [];
            for (let item of this.courses)
                data["courses"].push(item);
        }
        return data;
    }
}

export interface IArchiveProgramConfig {
    name?: string | undefined;
    courses?: string[] | undefined;
}

export class BaseHierarchyItem implements IBaseHierarchyItem {
    termCode?: number;
    prefix!: string;
    name!: string;
    sortOrder!: number;

    constructor(data?: IBaseHierarchyItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.termCode = _data["termCode"];
            this.prefix = _data["prefix"];
            this.name = _data["name"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): BaseHierarchyItem {
        data = typeof data === 'object' ? data : {};
        let result = new BaseHierarchyItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termCode"] = this.termCode;
        data["prefix"] = this.prefix;
        data["name"] = this.name;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IBaseHierarchyItem {
    termCode?: number;
    prefix: string;
    name: string;
    sortOrder: number;
}

export class CourseVM extends BaseHierarchyItem implements ICourseVM {
    courseId?: number;
    startTermCode?: number;
    endTermCode?: number | undefined;
    classNumber?: string | undefined;
    sequence?: string | undefined;
    suffix?: string | undefined;
    description?: string | undefined;
    fullCourseName?: string | undefined;
    isCrossListed?: boolean;
    maxUnits?: string | undefined;
    courseNotes?: string | undefined;
    termNotes?: string | undefined;
    duplicateCredit?: string | undefined;
    recommendedPrep?: string | undefined;
    geCode?: string | undefined;
    scheduledCourseCode?: CourseId | undefined;
    publishedCourseCode?: CourseId | undefined;
    matchedCourseCode?: CourseId | undefined;
    courseUnits?: number[] | undefined;
    sections?: SectionVM[] | undefined;
    prerequisiteCourseCodes?: RequisiteVM[] | undefined;
    corequisiteCourseCodes?: RequisiteVM[] | undefined;
    courseRestrictions?: RestrictionVm[] | undefined;
    majorRestrictions?: RestrictionVm[] | undefined;
    schoolRestrictions?: RestrictionVm[] | undefined;
    concurrentCourses?: ConcurrentVm[] | undefined;
    simpleSyllabusLookupUrl?: string | undefined;
    remainingSectionSeats?: number;
    sectionSeatCount?: number;

    constructor(data?: ICourseVM) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.courseId = _data["courseId"];
            this.startTermCode = _data["startTermCode"];
            this.endTermCode = _data["endTermCode"];
            this.classNumber = _data["classNumber"];
            this.sequence = _data["sequence"];
            this.suffix = _data["suffix"];
            this.description = _data["description"];
            this.fullCourseName = _data["fullCourseName"];
            this.isCrossListed = _data["isCrossListed"];
            this.maxUnits = _data["maxUnits"];
            this.courseNotes = _data["courseNotes"];
            this.termNotes = _data["termNotes"];
            this.duplicateCredit = _data["duplicateCredit"];
            this.recommendedPrep = _data["recommendedPrep"];
            this.geCode = _data["geCode"];
            this.scheduledCourseCode = _data["scheduledCourseCode"] ? CourseId.fromJS(_data["scheduledCourseCode"]) : <any>undefined;
            this.publishedCourseCode = _data["publishedCourseCode"] ? CourseId.fromJS(_data["publishedCourseCode"]) : <any>undefined;
            this.matchedCourseCode = _data["matchedCourseCode"] ? CourseId.fromJS(_data["matchedCourseCode"]) : <any>undefined;
            if (Array.isArray(_data["courseUnits"])) {
                this.courseUnits = [] as any;
                for (let item of _data["courseUnits"])
                    this.courseUnits!.push(item);
            }
            if (Array.isArray(_data["sections"])) {
                this.sections = [] as any;
                for (let item of _data["sections"])
                    this.sections!.push(SectionVM.fromJS(item));
            }
            if (Array.isArray(_data["prerequisiteCourseCodes"])) {
                this.prerequisiteCourseCodes = [] as any;
                for (let item of _data["prerequisiteCourseCodes"])
                    this.prerequisiteCourseCodes!.push(RequisiteVM.fromJS(item));
            }
            if (Array.isArray(_data["corequisiteCourseCodes"])) {
                this.corequisiteCourseCodes = [] as any;
                for (let item of _data["corequisiteCourseCodes"])
                    this.corequisiteCourseCodes!.push(RequisiteVM.fromJS(item));
            }
            if (Array.isArray(_data["courseRestrictions"])) {
                this.courseRestrictions = [] as any;
                for (let item of _data["courseRestrictions"])
                    this.courseRestrictions!.push(RestrictionVm.fromJS(item));
            }
            if (Array.isArray(_data["majorRestrictions"])) {
                this.majorRestrictions = [] as any;
                for (let item of _data["majorRestrictions"])
                    this.majorRestrictions!.push(RestrictionVm.fromJS(item));
            }
            if (Array.isArray(_data["schoolRestrictions"])) {
                this.schoolRestrictions = [] as any;
                for (let item of _data["schoolRestrictions"])
                    this.schoolRestrictions!.push(RestrictionVm.fromJS(item));
            }
            if (Array.isArray(_data["concurrentCourses"])) {
                this.concurrentCourses = [] as any;
                for (let item of _data["concurrentCourses"])
                    this.concurrentCourses!.push(ConcurrentVm.fromJS(item));
            }
            this.simpleSyllabusLookupUrl = _data["simpleSyllabusLookupUrl"];
            this.remainingSectionSeats = _data["remainingSectionSeats"];
            this.sectionSeatCount = _data["sectionSeatCount"];
        }
    }

    static override fromJS(data: any): CourseVM {
        data = typeof data === 'object' ? data : {};
        let result = new CourseVM();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseId"] = this.courseId;
        data["startTermCode"] = this.startTermCode;
        data["endTermCode"] = this.endTermCode;
        data["classNumber"] = this.classNumber;
        data["sequence"] = this.sequence;
        data["suffix"] = this.suffix;
        data["description"] = this.description;
        data["fullCourseName"] = this.fullCourseName;
        data["isCrossListed"] = this.isCrossListed;
        data["maxUnits"] = this.maxUnits;
        data["courseNotes"] = this.courseNotes;
        data["termNotes"] = this.termNotes;
        data["duplicateCredit"] = this.duplicateCredit;
        data["recommendedPrep"] = this.recommendedPrep;
        data["geCode"] = this.geCode;
        data["scheduledCourseCode"] = this.scheduledCourseCode ? this.scheduledCourseCode.toJSON() : <any>undefined;
        data["publishedCourseCode"] = this.publishedCourseCode ? this.publishedCourseCode.toJSON() : <any>undefined;
        data["matchedCourseCode"] = this.matchedCourseCode ? this.matchedCourseCode.toJSON() : <any>undefined;
        if (Array.isArray(this.courseUnits)) {
            data["courseUnits"] = [];
            for (let item of this.courseUnits)
                data["courseUnits"].push(item);
        }
        if (Array.isArray(this.sections)) {
            data["sections"] = [];
            for (let item of this.sections)
                data["sections"].push(item.toJSON());
        }
        if (Array.isArray(this.prerequisiteCourseCodes)) {
            data["prerequisiteCourseCodes"] = [];
            for (let item of this.prerequisiteCourseCodes)
                data["prerequisiteCourseCodes"].push(item.toJSON());
        }
        if (Array.isArray(this.corequisiteCourseCodes)) {
            data["corequisiteCourseCodes"] = [];
            for (let item of this.corequisiteCourseCodes)
                data["corequisiteCourseCodes"].push(item.toJSON());
        }
        if (Array.isArray(this.courseRestrictions)) {
            data["courseRestrictions"] = [];
            for (let item of this.courseRestrictions)
                data["courseRestrictions"].push(item.toJSON());
        }
        if (Array.isArray(this.majorRestrictions)) {
            data["majorRestrictions"] = [];
            for (let item of this.majorRestrictions)
                data["majorRestrictions"].push(item.toJSON());
        }
        if (Array.isArray(this.schoolRestrictions)) {
            data["schoolRestrictions"] = [];
            for (let item of this.schoolRestrictions)
                data["schoolRestrictions"].push(item.toJSON());
        }
        if (Array.isArray(this.concurrentCourses)) {
            data["concurrentCourses"] = [];
            for (let item of this.concurrentCourses)
                data["concurrentCourses"].push(item.toJSON());
        }
        data["simpleSyllabusLookupUrl"] = this.simpleSyllabusLookupUrl;
        data["remainingSectionSeats"] = this.remainingSectionSeats;
        data["sectionSeatCount"] = this.sectionSeatCount;
        super.toJSON(data);
        return data;
    }
}

export interface ICourseVM extends IBaseHierarchyItem {
    courseId?: number;
    startTermCode?: number;
    endTermCode?: number | undefined;
    classNumber?: string | undefined;
    sequence?: string | undefined;
    suffix?: string | undefined;
    description?: string | undefined;
    fullCourseName?: string | undefined;
    isCrossListed?: boolean;
    maxUnits?: string | undefined;
    courseNotes?: string | undefined;
    termNotes?: string | undefined;
    duplicateCredit?: string | undefined;
    recommendedPrep?: string | undefined;
    geCode?: string | undefined;
    scheduledCourseCode?: CourseId | undefined;
    publishedCourseCode?: CourseId | undefined;
    matchedCourseCode?: CourseId | undefined;
    courseUnits?: number[] | undefined;
    sections?: SectionVM[] | undefined;
    prerequisiteCourseCodes?: RequisiteVM[] | undefined;
    corequisiteCourseCodes?: RequisiteVM[] | undefined;
    courseRestrictions?: RestrictionVm[] | undefined;
    majorRestrictions?: RestrictionVm[] | undefined;
    schoolRestrictions?: RestrictionVm[] | undefined;
    concurrentCourses?: ConcurrentVm[] | undefined;
    simpleSyllabusLookupUrl?: string | undefined;
    remainingSectionSeats?: number;
    sectionSeatCount?: number;
}

export class CourseId implements ICourseId {
    prefix?: string | undefined;
    number?: string | undefined;
    suffix?: string | undefined;
    courseHyphen?: string | undefined;
    courseSpace?: string | undefined;
    courseSmashed?: string | undefined;

    constructor(data?: ICourseId) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prefix = _data["prefix"];
            this.number = _data["number"];
            this.suffix = _data["suffix"];
            this.courseHyphen = _data["courseHyphen"];
            this.courseSpace = _data["courseSpace"];
            this.courseSmashed = _data["courseSmashed"];
        }
    }

    static fromJS(data: any): CourseId {
        data = typeof data === 'object' ? data : {};
        let result = new CourseId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prefix"] = this.prefix;
        data["number"] = this.number;
        data["suffix"] = this.suffix;
        data["courseHyphen"] = this.courseHyphen;
        data["courseSpace"] = this.courseSpace;
        data["courseSmashed"] = this.courseSmashed;
        return data;
    }
}

export interface ICourseId {
    prefix?: string | undefined;
    number?: string | undefined;
    suffix?: string | undefined;
    courseHyphen?: string | undefined;
    courseSpace?: string | undefined;
    courseSmashed?: string | undefined;
}

export class SectionVM extends BaseTermVM implements ISectionVM {
    sisSectionId?: string | undefined;
    linkCode?: string | undefined;
    linkCodeForSort?: string | undefined;
    rnrSessionId?: number;
    peSectionId?: number;
    courseId?: number;
    hasDClearance?: boolean;
    classType?: string | undefined;
    name?: string | undefined;
    notes?: string | undefined;
    description?: string | undefined;
    group?: string | undefined;
    schedule?: ScheduleVM[] | undefined;
    totalSeats?: number | undefined;
    registeredSeats?: number | undefined;
    rnrMode?: string | undefined;
    session?: SessionVM | undefined;
    units?: string[] | undefined;
    instructors?: InstructorVM[] | undefined;
    syllabus?: string | undefined;
    isCancelled?: boolean;
    isFull?: boolean;
    rnrModeCode?: string | undefined;

    constructor(data?: ISectionVM) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sisSectionId = _data["sisSectionId"];
            this.linkCode = _data["linkCode"];
            this.linkCodeForSort = _data["linkCodeForSort"];
            this.rnrSessionId = _data["rnrSessionId"];
            this.peSectionId = _data["peSectionId"];
            this.courseId = _data["courseId"];
            this.hasDClearance = _data["hasDClearance"];
            this.classType = _data["classType"];
            this.name = _data["name"];
            this.notes = _data["notes"];
            this.description = _data["description"];
            this.group = _data["group"];
            if (Array.isArray(_data["schedule"])) {
                this.schedule = [] as any;
                for (let item of _data["schedule"])
                    this.schedule!.push(ScheduleVM.fromJS(item));
            }
            this.totalSeats = _data["totalSeats"];
            this.registeredSeats = _data["registeredSeats"];
            this.rnrMode = _data["rnrMode"];
            this.session = _data["session"] ? SessionVM.fromJS(_data["session"]) : <any>undefined;
            if (Array.isArray(_data["units"])) {
                this.units = [] as any;
                for (let item of _data["units"])
                    this.units!.push(item);
            }
            if (Array.isArray(_data["instructors"])) {
                this.instructors = [] as any;
                for (let item of _data["instructors"])
                    this.instructors!.push(InstructorVM.fromJS(item));
            }
            this.syllabus = _data["syllabus"];
            this.isCancelled = _data["isCancelled"];
            this.isFull = _data["isFull"];
            this.rnrModeCode = _data["rnrModeCode"];
        }
    }

    static override fromJS(data: any): SectionVM {
        data = typeof data === 'object' ? data : {};
        let result = new SectionVM();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sisSectionId"] = this.sisSectionId;
        data["linkCode"] = this.linkCode;
        data["linkCodeForSort"] = this.linkCodeForSort;
        data["rnrSessionId"] = this.rnrSessionId;
        data["peSectionId"] = this.peSectionId;
        data["courseId"] = this.courseId;
        data["hasDClearance"] = this.hasDClearance;
        data["classType"] = this.classType;
        data["name"] = this.name;
        data["notes"] = this.notes;
        data["description"] = this.description;
        data["group"] = this.group;
        if (Array.isArray(this.schedule)) {
            data["schedule"] = [];
            for (let item of this.schedule)
                data["schedule"].push(item.toJSON());
        }
        data["totalSeats"] = this.totalSeats;
        data["registeredSeats"] = this.registeredSeats;
        data["rnrMode"] = this.rnrMode;
        data["session"] = this.session ? this.session.toJSON() : <any>undefined;
        if (Array.isArray(this.units)) {
            data["units"] = [];
            for (let item of this.units)
                data["units"].push(item);
        }
        if (Array.isArray(this.instructors)) {
            data["instructors"] = [];
            for (let item of this.instructors)
                data["instructors"].push(item.toJSON());
        }
        data["syllabus"] = this.syllabus;
        data["isCancelled"] = this.isCancelled;
        data["isFull"] = this.isFull;
        data["rnrModeCode"] = this.rnrModeCode;
        super.toJSON(data);
        return data;
    }
}

export interface ISectionVM extends IBaseTermVM {
    sisSectionId?: string | undefined;
    linkCode?: string | undefined;
    linkCodeForSort?: string | undefined;
    rnrSessionId?: number;
    peSectionId?: number;
    courseId?: number;
    hasDClearance?: boolean;
    classType?: string | undefined;
    name?: string | undefined;
    notes?: string | undefined;
    description?: string | undefined;
    group?: string | undefined;
    schedule?: ScheduleVM[] | undefined;
    totalSeats?: number | undefined;
    registeredSeats?: number | undefined;
    rnrMode?: string | undefined;
    session?: SessionVM | undefined;
    units?: string[] | undefined;
    instructors?: InstructorVM[] | undefined;
    syllabus?: string | undefined;
    isCancelled?: boolean;
    isFull?: boolean;
    rnrModeCode?: string | undefined;
}

export class ScheduleVM implements IScheduleVM {
    dayCode?: string | undefined;
    days?: string[] | undefined;
    startTime?: string | undefined;
    endTime?: string | undefined;
    location?: string | undefined;
    building?: string | undefined;
    room?: string | undefined;
    sectionLocationSqNumber?: number | undefined;
    buildingRoom?: string | undefined;

    constructor(data?: IScheduleVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dayCode = _data["dayCode"];
            if (Array.isArray(_data["days"])) {
                this.days = [] as any;
                for (let item of _data["days"])
                    this.days!.push(item);
            }
            this.startTime = _data["startTime"];
            this.endTime = _data["endTime"];
            this.location = _data["location"];
            this.building = _data["building"];
            this.room = _data["room"];
            this.sectionLocationSqNumber = _data["sectionLocationSqNumber"];
            this.buildingRoom = _data["buildingRoom"];
        }
    }

    static fromJS(data: any): ScheduleVM {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dayCode"] = this.dayCode;
        if (Array.isArray(this.days)) {
            data["days"] = [];
            for (let item of this.days)
                data["days"].push(item);
        }
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        data["location"] = this.location;
        data["building"] = this.building;
        data["room"] = this.room;
        data["sectionLocationSqNumber"] = this.sectionLocationSqNumber;
        data["buildingRoom"] = this.buildingRoom;
        return data;
    }
}

export interface IScheduleVM {
    dayCode?: string | undefined;
    days?: string[] | undefined;
    startTime?: string | undefined;
    endTime?: string | undefined;
    location?: string | undefined;
    building?: string | undefined;
    room?: string | undefined;
    sectionLocationSqNumber?: number | undefined;
    buildingRoom?: string | undefined;
}

export class SessionVM implements ISessionVM {
    termCode?: string | undefined;
    rnrSessionCode?: string | undefined;
    description?: string | undefined;
    rnrSessionId?: number;

    constructor(data?: ISessionVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.termCode = _data["termCode"];
            this.rnrSessionCode = _data["rnrSessionCode"];
            this.description = _data["description"];
            this.rnrSessionId = _data["rnrSessionId"];
        }
    }

    static fromJS(data: any): SessionVM {
        data = typeof data === 'object' ? data : {};
        let result = new SessionVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termCode"] = this.termCode;
        data["rnrSessionCode"] = this.rnrSessionCode;
        data["description"] = this.description;
        data["rnrSessionId"] = this.rnrSessionId;
        return data;
    }
}

export interface ISessionVM {
    termCode?: string | undefined;
    rnrSessionCode?: string | undefined;
    description?: string | undefined;
    rnrSessionId?: number;
}

export class InstructorVM implements IInstructorVM {
    firstName?: string | undefined;
    lastName?: string | undefined;

    constructor(data?: IInstructorVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
        }
    }

    static fromJS(data: any): InstructorVM {
        data = typeof data === 'object' ? data : {};
        let result = new InstructorVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        return data;
    }
}

export interface IInstructorVM {
    firstName?: string | undefined;
    lastName?: string | undefined;
}

export class RequisiteVM implements IRequisiteVM {
    order?: number;
    requiredCourses?: number;
    courseOptions?: CourseCodeVM[] | undefined;

    constructor(data?: IRequisiteVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"];
            this.requiredCourses = _data["requiredCourses"];
            if (Array.isArray(_data["courseOptions"])) {
                this.courseOptions = [] as any;
                for (let item of _data["courseOptions"])
                    this.courseOptions!.push(CourseCodeVM.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RequisiteVM {
        data = typeof data === 'object' ? data : {};
        let result = new RequisiteVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order;
        data["requiredCourses"] = this.requiredCourses;
        if (Array.isArray(this.courseOptions)) {
            data["courseOptions"] = [];
            for (let item of this.courseOptions)
                data["courseOptions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRequisiteVM {
    order?: number;
    requiredCourses?: number;
    courseOptions?: CourseCodeVM[] | undefined;
}

export class CourseCodeVM extends CourseId implements ICourseCodeVM {
    theRest?: string | undefined;
    ands?: CourseCodeVM[] | undefined;

    constructor(data?: ICourseCodeVM) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.theRest = _data["theRest"];
            if (Array.isArray(_data["ands"])) {
                this.ands = [] as any;
                for (let item of _data["ands"])
                    this.ands!.push(CourseCodeVM.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): CourseCodeVM {
        data = typeof data === 'object' ? data : {};
        let result = new CourseCodeVM();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["theRest"] = this.theRest;
        if (Array.isArray(this.ands)) {
            data["ands"] = [];
            for (let item of this.ands)
                data["ands"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICourseCodeVM extends ICourseId {
    theRest?: string | undefined;
    ands?: CourseCodeVM[] | undefined;
}

export class RestrictionVm implements IRestrictionVm {
    groupCode?: string | undefined;
    groupDescription?: string | undefined;
    restrictionCode?: string | undefined;
    restriction?: RestrictionType | undefined;

    constructor(data?: IRestrictionVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupCode = _data["groupCode"];
            this.groupDescription = _data["groupDescription"];
            this.restrictionCode = _data["restrictionCode"];
            this.restriction = _data["restriction"];
        }
    }

    static fromJS(data: any): RestrictionVm {
        data = typeof data === 'object' ? data : {};
        let result = new RestrictionVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupCode"] = this.groupCode;
        data["groupDescription"] = this.groupDescription;
        data["restrictionCode"] = this.restrictionCode;
        data["restriction"] = this.restriction;
        return data;
    }
}

export interface IRestrictionVm {
    groupCode?: string | undefined;
    groupDescription?: string | undefined;
    restrictionCode?: string | undefined;
    restriction?: RestrictionType | undefined;
}

export enum RestrictionType {
    Inclusive = "Inclusive",
    Exclusive = "Exclusive",
}

export class ConcurrentVm implements IConcurrentVm {
    courseId?: string | undefined;
    sortOrder?: number;

    constructor(data?: IConcurrentVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseId = _data["courseId"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): ConcurrentVm {
        data = typeof data === 'object' ? data : {};
        let result = new ConcurrentVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseId"] = this.courseId;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IConcurrentVm {
    courseId?: string | undefined;
    sortOrder?: number;
}

export class TermCourses implements ITermCourses {
    termCode?: number;
    courses?: CourseVM[] | undefined;

    constructor(data?: ITermCourses) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.termCode = _data["termCode"];
            if (Array.isArray(_data["courses"])) {
                this.courses = [] as any;
                for (let item of _data["courses"])
                    this.courses!.push(CourseVM.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TermCourses {
        data = typeof data === 'object' ? data : {};
        let result = new TermCourses();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termCode"] = this.termCode;
        if (Array.isArray(this.courses)) {
            data["courses"] = [];
            for (let item of this.courses)
                data["courses"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITermCourses {
    termCode?: number;
    courses?: CourseVM[] | undefined;
}

export class ProgramCoursesVM extends TermCourses implements IProgramCoursesVM {
    schoolPrefix?: string | undefined;
    programPrefix?: string | undefined;
    gePrefix?: string | undefined;

    constructor(data?: IProgramCoursesVM) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.schoolPrefix = _data["schoolPrefix"];
            this.programPrefix = _data["programPrefix"];
            this.gePrefix = _data["gePrefix"];
        }
    }

    static override fromJS(data: any): ProgramCoursesVM {
        data = typeof data === 'object' ? data : {};
        let result = new ProgramCoursesVM();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["schoolPrefix"] = this.schoolPrefix;
        data["programPrefix"] = this.programPrefix;
        data["gePrefix"] = this.gePrefix;
        super.toJSON(data);
        return data;
    }
}

export interface IProgramCoursesVM extends ITermCourses {
    schoolPrefix?: string | undefined;
    programPrefix?: string | undefined;
    gePrefix?: string | undefined;
}

export class GeCategoryCoursesVM extends TermCourses implements IGeCategoryCoursesVM {
    geRequirementPrefix?: string | undefined;
    geCategoryPrefix?: string | undefined;

    constructor(data?: IGeCategoryCoursesVM) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.geRequirementPrefix = _data["geRequirementPrefix"];
            this.geCategoryPrefix = _data["geCategoryPrefix"];
        }
    }

    static override fromJS(data: any): GeCategoryCoursesVM {
        data = typeof data === 'object' ? data : {};
        let result = new GeCategoryCoursesVM();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["geRequirementPrefix"] = this.geRequirementPrefix;
        data["geCategoryPrefix"] = this.geCategoryPrefix;
        super.toJSON(data);
        return data;
    }
}

export interface IGeCategoryCoursesVM extends ITermCourses {
    geRequirementPrefix?: string | undefined;
    geCategoryPrefix?: string | undefined;
}

export class ConfigurationCourseDefinition implements IConfigurationCourseDefinition {
    termCode?: number;
    groupingPrefix?: string | undefined;
    prefixes?: PreviewPrefix[] | undefined;
    courses?: PreviewCourse[] | undefined;

    constructor(data?: IConfigurationCourseDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.termCode = _data["termCode"];
            this.groupingPrefix = _data["groupingPrefix"];
            if (Array.isArray(_data["prefixes"])) {
                this.prefixes = [] as any;
                for (let item of _data["prefixes"])
                    this.prefixes!.push(PreviewPrefix.fromJS(item));
            }
            if (Array.isArray(_data["courses"])) {
                this.courses = [] as any;
                for (let item of _data["courses"])
                    this.courses!.push(PreviewCourse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConfigurationCourseDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationCourseDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termCode"] = this.termCode;
        data["groupingPrefix"] = this.groupingPrefix;
        if (Array.isArray(this.prefixes)) {
            data["prefixes"] = [];
            for (let item of this.prefixes)
                data["prefixes"].push(item.toJSON());
        }
        if (Array.isArray(this.courses)) {
            data["courses"] = [];
            for (let item of this.courses)
                data["courses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IConfigurationCourseDefinition {
    termCode?: number;
    groupingPrefix?: string | undefined;
    prefixes?: PreviewPrefix[] | undefined;
    courses?: PreviewCourse[] | undefined;
}

export class PreviewPrefix implements IPreviewPrefix {
    prefix?: string | undefined;
    isAnyPrefix?: boolean;
    sessionCode?: string | undefined;
    isAnySessionCode?: boolean;
    geCode?: string | undefined;
    isAnyGeCode?: boolean;

    constructor(data?: IPreviewPrefix) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prefix = _data["prefix"];
            this.isAnyPrefix = _data["isAnyPrefix"];
            this.sessionCode = _data["sessionCode"];
            this.isAnySessionCode = _data["isAnySessionCode"];
            this.geCode = _data["geCode"];
            this.isAnyGeCode = _data["isAnyGeCode"];
        }
    }

    static fromJS(data: any): PreviewPrefix {
        data = typeof data === 'object' ? data : {};
        let result = new PreviewPrefix();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prefix"] = this.prefix;
        data["isAnyPrefix"] = this.isAnyPrefix;
        data["sessionCode"] = this.sessionCode;
        data["isAnySessionCode"] = this.isAnySessionCode;
        data["geCode"] = this.geCode;
        data["isAnyGeCode"] = this.isAnyGeCode;
        return data;
    }
}

export interface IPreviewPrefix {
    prefix?: string | undefined;
    isAnyPrefix?: boolean;
    sessionCode?: string | undefined;
    isAnySessionCode?: boolean;
    geCode?: string | undefined;
    isAnyGeCode?: boolean;
}

export class PreviewCourse implements IPreviewCourse {
    prefix?: string | undefined;
    classNumber?: number;
    sequence?: string | undefined;

    constructor(data?: IPreviewCourse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prefix = _data["prefix"];
            this.classNumber = _data["classNumber"];
            this.sequence = _data["sequence"];
        }
    }

    static fromJS(data: any): PreviewCourse {
        data = typeof data === 'object' ? data : {};
        let result = new PreviewCourse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prefix"] = this.prefix;
        data["classNumber"] = this.classNumber;
        data["sequence"] = this.sequence;
        return data;
    }
}

export interface IPreviewCourse {
    prefix?: string | undefined;
    classNumber?: number;
    sequence?: string | undefined;
}

export class GeVM implements IGeVM {
    termCode?: number;
    geGroups?: GeGroupVM[] | undefined;

    constructor(data?: IGeVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.termCode = _data["termCode"];
            if (Array.isArray(_data["geGroups"])) {
                this.geGroups = [] as any;
                for (let item of _data["geGroups"])
                    this.geGroups!.push(GeGroupVM.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GeVM {
        data = typeof data === 'object' ? data : {};
        let result = new GeVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termCode"] = this.termCode;
        if (Array.isArray(this.geGroups)) {
            data["geGroups"] = [];
            for (let item of this.geGroups)
                data["geGroups"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGeVM {
    termCode?: number;
    geGroups?: GeGroupVM[] | undefined;
}

export class GeGroupVM implements IGeGroupVM {
    groupType?: GeGroupType;
    requirements?: GeRequirementVM[] | undefined;

    constructor(data?: IGeGroupVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupType = _data["groupType"];
            if (Array.isArray(_data["requirements"])) {
                this.requirements = [] as any;
                for (let item of _data["requirements"])
                    this.requirements!.push(GeRequirementVM.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GeGroupVM {
        data = typeof data === 'object' ? data : {};
        let result = new GeGroupVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupType"] = this.groupType;
        if (Array.isArray(this.requirements)) {
            data["requirements"] = [];
            for (let item of this.requirements)
                data["requirements"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGeGroupVM {
    groupType?: GeGroupType;
    requirements?: GeRequirementVM[] | undefined;
}

export class GeRequirementVM implements IGeRequirementVM {
    name?: string | undefined;
    id?: number;
    prefix?: string | undefined;
    categories?: GeCategoriesVM[] | undefined;
    sortOrder?: number;

    constructor(data?: IGeRequirementVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
            this.prefix = _data["prefix"];
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(GeCategoriesVM.fromJS(item));
            }
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): GeRequirementVM {
        data = typeof data === 'object' ? data : {};
        let result = new GeRequirementVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        data["prefix"] = this.prefix;
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IGeRequirementVM {
    name?: string | undefined;
    id?: number;
    prefix?: string | undefined;
    categories?: GeCategoriesVM[] | undefined;
    sortOrder?: number;
}

export class GeCategoriesVM implements IGeCategoriesVM {
    prefix?: string | undefined;
    name?: string | undefined;
    sortOrder?: number;

    constructor(data?: IGeCategoriesVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prefix = _data["prefix"];
            this.name = _data["name"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): GeCategoriesVM {
        data = typeof data === 'object' ? data : {};
        let result = new GeCategoriesVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prefix"] = this.prefix;
        data["name"] = this.name;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IGeCategoriesVM {
    prefix?: string | undefined;
    name?: string | undefined;
    sortOrder?: number;
}

export class GeCategoryDetailsVM extends BaseHierarchyItem implements IGeCategoryDetailsVM {
    programNote?: string | undefined;
    geRequirementPrefix?: string | undefined;

    constructor(data?: IGeCategoryDetailsVM) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.programNote = _data["programNote"];
            this.geRequirementPrefix = _data["geRequirementPrefix"];
        }
    }

    static override fromJS(data: any): GeCategoryDetailsVM {
        data = typeof data === 'object' ? data : {};
        let result = new GeCategoryDetailsVM();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["programNote"] = this.programNote;
        data["geRequirementPrefix"] = this.geRequirementPrefix;
        super.toJSON(data);
        return data;
    }
}

export interface IGeCategoryDetailsVM extends IBaseHierarchyItem {
    programNote?: string | undefined;
    geRequirementPrefix?: string | undefined;
}

export class PeTerm implements IPeTerm {
    termCode?: string | undefined;
    description?: string | undefined;
    termBeginDate?: Date | undefined;

    constructor(data?: IPeTerm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.termCode = _data["termCode"];
            this.description = _data["description"];
            this.termBeginDate = _data["termBeginDate"] ? new Date(_data["termBeginDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PeTerm {
        data = typeof data === 'object' ? data : {};
        let result = new PeTerm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termCode"] = this.termCode;
        data["description"] = this.description;
        data["termBeginDate"] = this.termBeginDate ? this.termBeginDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPeTerm {
    termCode?: string | undefined;
    description?: string | undefined;
    termBeginDate?: Date | undefined;
}

export class PeSession implements IPeSession {
    sections?: PeSection[] | undefined;
    sectionWrs?: PeSectionWr[] | undefined;
    termCode!: string;
    rnrSessionCode!: string;
    description?: string | undefined;
    lastDropDateDbDate?: Date | undefined;
    lastDropDate?: Date | undefined;
    rnrSessionId?: number;
    sisSessionId!: string;
    gradingCycleCode?: string | undefined;
    ugUnitTuitionFeeCode?: string | undefined;
    gFlatTuitionFeeCode?: string | undefined;
    gUnitTuitionFeeCode?: string | undefined;
    ugFlatTuitionFeeCode?: string | undefined;
    partHealthFeeCode?: string | undefined;
    summerWeekHealthFeeCode?: string | undefined;
    summerMaxHealthFeeCode?: string | undefined;
    studentFeeCode?: string | undefined;
    fullHealthFeeCode?: string | undefined;
    lastApplyDate?: Date | undefined;
    preRegBeginDate?: Date | undefined;
    preRegEndDate?: Date | undefined;
    earlyRegBeginDate?: Date | undefined;
    earlyRegEndDate?: Date | undefined;
    regBeginDate?: Date | undefined;
    regEndDate?: Date | undefined;
    classBeginDbDate?: Date | undefined;
    classBeginDate?: Date | undefined;
    classEndDbDate?: Date | undefined;
    classEndDate?: Date | undefined;
    lateRegBeginDate?: Date | undefined;
    lateRegEndDate?: Date | undefined;
    healthInsuranceDueDate?: Date | undefined;
    withdrawWOWDbDate?: Date | undefined;
    withdrawWOWDate?: Date | undefined;
    withdrawWWDateDbDate?: Date | undefined;
    withdrawWWDate?: Date | undefined;
    gradePostDate?: Date | undefined;
    fullTimeUnitCode?: string | undefined;
    stopDate?: Date | undefined;
    orientationFeeCode?: string | undefined;
    week2BeginDate?: Date | undefined;
    week2EndDate?: Date | undefined;
    week2PercentPenalty?: number | undefined;
    week2FeeCode?: string | undefined;
    week3BeginDate?: Date | undefined;
    week3EndDate?: Date | undefined;
    week3PercentPenalty?: number | undefined;
    week3FeeCode?: string | undefined;
    orientationMandatory?: string | undefined;
    oissMandatory?: string | undefined;
    oissFeeCode?: string | undefined;
    rnrSessionOper?: string | undefined;
    trxPrintD?: string | undefined;
    burOper?: string | undefined;
    gradOrientationMandatory?: string | undefined;
    gradOrientationFeeCode?: string | undefined;
    finalExamBeginDbDate?: Date | undefined;
    finalExamBeginDate?: Date | undefined;
    finalExamEndDbDate?: Date | undefined;
    finalExamEndDate?: Date | undefined;
    f211?: string | undefined;
    insuranceMinimumUnits?: number | undefined;
    uscCampusCode?: string | undefined;
    midtermGradingBeginDate?: Date | undefined;
    midtermGradingEndDate?: Date | undefined;
    finalGradingBeginDate?: Date | undefined;
    finalGradingEndDate?: Date | undefined;
    contactName?: string | undefined;
    contactPhone?: string | undefined;
    break1BeginDbDate?: Date | undefined;
    break1BeginDate?: Date | undefined;
    break1EndDbDate?: Date | undefined;
    break1EndDate?: Date | undefined;
    break2BeginDbDate?: Date | undefined;
    break2BeginDate?: Date | undefined;
    break2EndDbDate?: Date | undefined;
    break2EndDate?: Date | undefined;
    summerTid?: string | undefined;
    lastEnrollmentOptionDbDate?: Date | undefined;
    lastEnrollmentOptionDate?: Date | undefined;

    constructor(data?: IPeSession) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["sections"])) {
                this.sections = [] as any;
                for (let item of _data["sections"])
                    this.sections!.push(PeSection.fromJS(item));
            }
            if (Array.isArray(_data["sectionWrs"])) {
                this.sectionWrs = [] as any;
                for (let item of _data["sectionWrs"])
                    this.sectionWrs!.push(PeSectionWr.fromJS(item));
            }
            this.termCode = _data["termCode"];
            this.rnrSessionCode = _data["rnrSessionCode"];
            this.description = _data["description"];
            this.lastDropDateDbDate = _data["lastDropDateDbDate"] ? new Date(_data["lastDropDateDbDate"].toString()) : <any>undefined;
            this.lastDropDate = _data["lastDropDate"] ? new Date(_data["lastDropDate"].toString()) : <any>undefined;
            this.rnrSessionId = _data["rnrSessionId"];
            this.sisSessionId = _data["sisSessionId"];
            this.gradingCycleCode = _data["gradingCycleCode"];
            this.ugUnitTuitionFeeCode = _data["ugUnitTuitionFeeCode"];
            this.gFlatTuitionFeeCode = _data["gFlatTuitionFeeCode"];
            this.gUnitTuitionFeeCode = _data["gUnitTuitionFeeCode"];
            this.ugFlatTuitionFeeCode = _data["ugFlatTuitionFeeCode"];
            this.partHealthFeeCode = _data["partHealthFeeCode"];
            this.summerWeekHealthFeeCode = _data["summerWeekHealthFeeCode"];
            this.summerMaxHealthFeeCode = _data["summerMaxHealthFeeCode"];
            this.studentFeeCode = _data["studentFeeCode"];
            this.fullHealthFeeCode = _data["fullHealthFeeCode"];
            this.lastApplyDate = _data["lastApplyDate"] ? new Date(_data["lastApplyDate"].toString()) : <any>undefined;
            this.preRegBeginDate = _data["preRegBeginDate"] ? new Date(_data["preRegBeginDate"].toString()) : <any>undefined;
            this.preRegEndDate = _data["preRegEndDate"] ? new Date(_data["preRegEndDate"].toString()) : <any>undefined;
            this.earlyRegBeginDate = _data["earlyRegBeginDate"] ? new Date(_data["earlyRegBeginDate"].toString()) : <any>undefined;
            this.earlyRegEndDate = _data["earlyRegEndDate"] ? new Date(_data["earlyRegEndDate"].toString()) : <any>undefined;
            this.regBeginDate = _data["regBeginDate"] ? new Date(_data["regBeginDate"].toString()) : <any>undefined;
            this.regEndDate = _data["regEndDate"] ? new Date(_data["regEndDate"].toString()) : <any>undefined;
            this.classBeginDbDate = _data["classBeginDbDate"] ? new Date(_data["classBeginDbDate"].toString()) : <any>undefined;
            this.classBeginDate = _data["classBeginDate"] ? new Date(_data["classBeginDate"].toString()) : <any>undefined;
            this.classEndDbDate = _data["classEndDbDate"] ? new Date(_data["classEndDbDate"].toString()) : <any>undefined;
            this.classEndDate = _data["classEndDate"] ? new Date(_data["classEndDate"].toString()) : <any>undefined;
            this.lateRegBeginDate = _data["lateRegBeginDate"] ? new Date(_data["lateRegBeginDate"].toString()) : <any>undefined;
            this.lateRegEndDate = _data["lateRegEndDate"] ? new Date(_data["lateRegEndDate"].toString()) : <any>undefined;
            this.healthInsuranceDueDate = _data["healthInsuranceDueDate"] ? new Date(_data["healthInsuranceDueDate"].toString()) : <any>undefined;
            this.withdrawWOWDbDate = _data["withdrawWOWDbDate"] ? new Date(_data["withdrawWOWDbDate"].toString()) : <any>undefined;
            this.withdrawWOWDate = _data["withdrawWOWDate"] ? new Date(_data["withdrawWOWDate"].toString()) : <any>undefined;
            this.withdrawWWDateDbDate = _data["withdrawWWDateDbDate"] ? new Date(_data["withdrawWWDateDbDate"].toString()) : <any>undefined;
            this.withdrawWWDate = _data["withdrawWWDate"] ? new Date(_data["withdrawWWDate"].toString()) : <any>undefined;
            this.gradePostDate = _data["gradePostDate"] ? new Date(_data["gradePostDate"].toString()) : <any>undefined;
            this.fullTimeUnitCode = _data["fullTimeUnitCode"];
            this.stopDate = _data["stopDate"] ? new Date(_data["stopDate"].toString()) : <any>undefined;
            this.orientationFeeCode = _data["orientationFeeCode"];
            this.week2BeginDate = _data["week2BeginDate"] ? new Date(_data["week2BeginDate"].toString()) : <any>undefined;
            this.week2EndDate = _data["week2EndDate"] ? new Date(_data["week2EndDate"].toString()) : <any>undefined;
            this.week2PercentPenalty = _data["week2PercentPenalty"];
            this.week2FeeCode = _data["week2FeeCode"];
            this.week3BeginDate = _data["week3BeginDate"] ? new Date(_data["week3BeginDate"].toString()) : <any>undefined;
            this.week3EndDate = _data["week3EndDate"] ? new Date(_data["week3EndDate"].toString()) : <any>undefined;
            this.week3PercentPenalty = _data["week3PercentPenalty"];
            this.week3FeeCode = _data["week3FeeCode"];
            this.orientationMandatory = _data["orientationMandatory"];
            this.oissMandatory = _data["oissMandatory"];
            this.oissFeeCode = _data["oissFeeCode"];
            this.rnrSessionOper = _data["rnrSessionOper"];
            this.trxPrintD = _data["trxPrintD"];
            this.burOper = _data["burOper"];
            this.gradOrientationMandatory = _data["gradOrientationMandatory"];
            this.gradOrientationFeeCode = _data["gradOrientationFeeCode"];
            this.finalExamBeginDbDate = _data["finalExamBeginDbDate"] ? new Date(_data["finalExamBeginDbDate"].toString()) : <any>undefined;
            this.finalExamBeginDate = _data["finalExamBeginDate"] ? new Date(_data["finalExamBeginDate"].toString()) : <any>undefined;
            this.finalExamEndDbDate = _data["finalExamEndDbDate"] ? new Date(_data["finalExamEndDbDate"].toString()) : <any>undefined;
            this.finalExamEndDate = _data["finalExamEndDate"] ? new Date(_data["finalExamEndDate"].toString()) : <any>undefined;
            this.f211 = _data["f211"];
            this.insuranceMinimumUnits = _data["insuranceMinimumUnits"];
            this.uscCampusCode = _data["uscCampusCode"];
            this.midtermGradingBeginDate = _data["midtermGradingBeginDate"] ? new Date(_data["midtermGradingBeginDate"].toString()) : <any>undefined;
            this.midtermGradingEndDate = _data["midtermGradingEndDate"] ? new Date(_data["midtermGradingEndDate"].toString()) : <any>undefined;
            this.finalGradingBeginDate = _data["finalGradingBeginDate"] ? new Date(_data["finalGradingBeginDate"].toString()) : <any>undefined;
            this.finalGradingEndDate = _data["finalGradingEndDate"] ? new Date(_data["finalGradingEndDate"].toString()) : <any>undefined;
            this.contactName = _data["contactName"];
            this.contactPhone = _data["contactPhone"];
            this.break1BeginDbDate = _data["break1BeginDbDate"] ? new Date(_data["break1BeginDbDate"].toString()) : <any>undefined;
            this.break1BeginDate = _data["break1BeginDate"] ? new Date(_data["break1BeginDate"].toString()) : <any>undefined;
            this.break1EndDbDate = _data["break1EndDbDate"] ? new Date(_data["break1EndDbDate"].toString()) : <any>undefined;
            this.break1EndDate = _data["break1EndDate"] ? new Date(_data["break1EndDate"].toString()) : <any>undefined;
            this.break2BeginDbDate = _data["break2BeginDbDate"] ? new Date(_data["break2BeginDbDate"].toString()) : <any>undefined;
            this.break2BeginDate = _data["break2BeginDate"] ? new Date(_data["break2BeginDate"].toString()) : <any>undefined;
            this.break2EndDbDate = _data["break2EndDbDate"] ? new Date(_data["break2EndDbDate"].toString()) : <any>undefined;
            this.break2EndDate = _data["break2EndDate"] ? new Date(_data["break2EndDate"].toString()) : <any>undefined;
            this.summerTid = _data["summerTid"];
            this.lastEnrollmentOptionDbDate = _data["lastEnrollmentOptionDbDate"] ? new Date(_data["lastEnrollmentOptionDbDate"].toString()) : <any>undefined;
            this.lastEnrollmentOptionDate = _data["lastEnrollmentOptionDate"] ? new Date(_data["lastEnrollmentOptionDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PeSession {
        data = typeof data === 'object' ? data : {};
        let result = new PeSession();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sections)) {
            data["sections"] = [];
            for (let item of this.sections)
                data["sections"].push(item.toJSON());
        }
        if (Array.isArray(this.sectionWrs)) {
            data["sectionWrs"] = [];
            for (let item of this.sectionWrs)
                data["sectionWrs"].push(item.toJSON());
        }
        data["termCode"] = this.termCode;
        data["rnrSessionCode"] = this.rnrSessionCode;
        data["description"] = this.description;
        data["lastDropDateDbDate"] = this.lastDropDateDbDate ? this.lastDropDateDbDate.toISOString() : <any>undefined;
        data["lastDropDate"] = this.lastDropDate ? this.lastDropDate.toISOString() : <any>undefined;
        data["rnrSessionId"] = this.rnrSessionId;
        data["sisSessionId"] = this.sisSessionId;
        data["gradingCycleCode"] = this.gradingCycleCode;
        data["ugUnitTuitionFeeCode"] = this.ugUnitTuitionFeeCode;
        data["gFlatTuitionFeeCode"] = this.gFlatTuitionFeeCode;
        data["gUnitTuitionFeeCode"] = this.gUnitTuitionFeeCode;
        data["ugFlatTuitionFeeCode"] = this.ugFlatTuitionFeeCode;
        data["partHealthFeeCode"] = this.partHealthFeeCode;
        data["summerWeekHealthFeeCode"] = this.summerWeekHealthFeeCode;
        data["summerMaxHealthFeeCode"] = this.summerMaxHealthFeeCode;
        data["studentFeeCode"] = this.studentFeeCode;
        data["fullHealthFeeCode"] = this.fullHealthFeeCode;
        data["lastApplyDate"] = this.lastApplyDate ? this.lastApplyDate.toISOString() : <any>undefined;
        data["preRegBeginDate"] = this.preRegBeginDate ? this.preRegBeginDate.toISOString() : <any>undefined;
        data["preRegEndDate"] = this.preRegEndDate ? this.preRegEndDate.toISOString() : <any>undefined;
        data["earlyRegBeginDate"] = this.earlyRegBeginDate ? this.earlyRegBeginDate.toISOString() : <any>undefined;
        data["earlyRegEndDate"] = this.earlyRegEndDate ? this.earlyRegEndDate.toISOString() : <any>undefined;
        data["regBeginDate"] = this.regBeginDate ? this.regBeginDate.toISOString() : <any>undefined;
        data["regEndDate"] = this.regEndDate ? this.regEndDate.toISOString() : <any>undefined;
        data["classBeginDbDate"] = this.classBeginDbDate ? this.classBeginDbDate.toISOString() : <any>undefined;
        data["classBeginDate"] = this.classBeginDate ? this.classBeginDate.toISOString() : <any>undefined;
        data["classEndDbDate"] = this.classEndDbDate ? this.classEndDbDate.toISOString() : <any>undefined;
        data["classEndDate"] = this.classEndDate ? this.classEndDate.toISOString() : <any>undefined;
        data["lateRegBeginDate"] = this.lateRegBeginDate ? this.lateRegBeginDate.toISOString() : <any>undefined;
        data["lateRegEndDate"] = this.lateRegEndDate ? this.lateRegEndDate.toISOString() : <any>undefined;
        data["healthInsuranceDueDate"] = this.healthInsuranceDueDate ? this.healthInsuranceDueDate.toISOString() : <any>undefined;
        data["withdrawWOWDbDate"] = this.withdrawWOWDbDate ? this.withdrawWOWDbDate.toISOString() : <any>undefined;
        data["withdrawWOWDate"] = this.withdrawWOWDate ? this.withdrawWOWDate.toISOString() : <any>undefined;
        data["withdrawWWDateDbDate"] = this.withdrawWWDateDbDate ? this.withdrawWWDateDbDate.toISOString() : <any>undefined;
        data["withdrawWWDate"] = this.withdrawWWDate ? this.withdrawWWDate.toISOString() : <any>undefined;
        data["gradePostDate"] = this.gradePostDate ? this.gradePostDate.toISOString() : <any>undefined;
        data["fullTimeUnitCode"] = this.fullTimeUnitCode;
        data["stopDate"] = this.stopDate ? this.stopDate.toISOString() : <any>undefined;
        data["orientationFeeCode"] = this.orientationFeeCode;
        data["week2BeginDate"] = this.week2BeginDate ? this.week2BeginDate.toISOString() : <any>undefined;
        data["week2EndDate"] = this.week2EndDate ? this.week2EndDate.toISOString() : <any>undefined;
        data["week2PercentPenalty"] = this.week2PercentPenalty;
        data["week2FeeCode"] = this.week2FeeCode;
        data["week3BeginDate"] = this.week3BeginDate ? this.week3BeginDate.toISOString() : <any>undefined;
        data["week3EndDate"] = this.week3EndDate ? this.week3EndDate.toISOString() : <any>undefined;
        data["week3PercentPenalty"] = this.week3PercentPenalty;
        data["week3FeeCode"] = this.week3FeeCode;
        data["orientationMandatory"] = this.orientationMandatory;
        data["oissMandatory"] = this.oissMandatory;
        data["oissFeeCode"] = this.oissFeeCode;
        data["rnrSessionOper"] = this.rnrSessionOper;
        data["trxPrintD"] = this.trxPrintD;
        data["burOper"] = this.burOper;
        data["gradOrientationMandatory"] = this.gradOrientationMandatory;
        data["gradOrientationFeeCode"] = this.gradOrientationFeeCode;
        data["finalExamBeginDbDate"] = this.finalExamBeginDbDate ? this.finalExamBeginDbDate.toISOString() : <any>undefined;
        data["finalExamBeginDate"] = this.finalExamBeginDate ? this.finalExamBeginDate.toISOString() : <any>undefined;
        data["finalExamEndDbDate"] = this.finalExamEndDbDate ? this.finalExamEndDbDate.toISOString() : <any>undefined;
        data["finalExamEndDate"] = this.finalExamEndDate ? this.finalExamEndDate.toISOString() : <any>undefined;
        data["f211"] = this.f211;
        data["insuranceMinimumUnits"] = this.insuranceMinimumUnits;
        data["uscCampusCode"] = this.uscCampusCode;
        data["midtermGradingBeginDate"] = this.midtermGradingBeginDate ? this.midtermGradingBeginDate.toISOString() : <any>undefined;
        data["midtermGradingEndDate"] = this.midtermGradingEndDate ? this.midtermGradingEndDate.toISOString() : <any>undefined;
        data["finalGradingBeginDate"] = this.finalGradingBeginDate ? this.finalGradingBeginDate.toISOString() : <any>undefined;
        data["finalGradingEndDate"] = this.finalGradingEndDate ? this.finalGradingEndDate.toISOString() : <any>undefined;
        data["contactName"] = this.contactName;
        data["contactPhone"] = this.contactPhone;
        data["break1BeginDbDate"] = this.break1BeginDbDate ? this.break1BeginDbDate.toISOString() : <any>undefined;
        data["break1BeginDate"] = this.break1BeginDate ? this.break1BeginDate.toISOString() : <any>undefined;
        data["break1EndDbDate"] = this.break1EndDbDate ? this.break1EndDbDate.toISOString() : <any>undefined;
        data["break1EndDate"] = this.break1EndDate ? this.break1EndDate.toISOString() : <any>undefined;
        data["break2BeginDbDate"] = this.break2BeginDbDate ? this.break2BeginDbDate.toISOString() : <any>undefined;
        data["break2BeginDate"] = this.break2BeginDate ? this.break2BeginDate.toISOString() : <any>undefined;
        data["break2EndDbDate"] = this.break2EndDbDate ? this.break2EndDbDate.toISOString() : <any>undefined;
        data["break2EndDate"] = this.break2EndDate ? this.break2EndDate.toISOString() : <any>undefined;
        data["summerTid"] = this.summerTid;
        data["lastEnrollmentOptionDbDate"] = this.lastEnrollmentOptionDbDate ? this.lastEnrollmentOptionDbDate.toISOString() : <any>undefined;
        data["lastEnrollmentOptionDate"] = this.lastEnrollmentOptionDate ? this.lastEnrollmentOptionDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPeSession {
    sections?: PeSection[] | undefined;
    sectionWrs?: PeSectionWr[] | undefined;
    termCode: string;
    rnrSessionCode: string;
    description?: string | undefined;
    lastDropDateDbDate?: Date | undefined;
    lastDropDate?: Date | undefined;
    rnrSessionId?: number;
    sisSessionId: string;
    gradingCycleCode?: string | undefined;
    ugUnitTuitionFeeCode?: string | undefined;
    gFlatTuitionFeeCode?: string | undefined;
    gUnitTuitionFeeCode?: string | undefined;
    ugFlatTuitionFeeCode?: string | undefined;
    partHealthFeeCode?: string | undefined;
    summerWeekHealthFeeCode?: string | undefined;
    summerMaxHealthFeeCode?: string | undefined;
    studentFeeCode?: string | undefined;
    fullHealthFeeCode?: string | undefined;
    lastApplyDate?: Date | undefined;
    preRegBeginDate?: Date | undefined;
    preRegEndDate?: Date | undefined;
    earlyRegBeginDate?: Date | undefined;
    earlyRegEndDate?: Date | undefined;
    regBeginDate?: Date | undefined;
    regEndDate?: Date | undefined;
    classBeginDbDate?: Date | undefined;
    classBeginDate?: Date | undefined;
    classEndDbDate?: Date | undefined;
    classEndDate?: Date | undefined;
    lateRegBeginDate?: Date | undefined;
    lateRegEndDate?: Date | undefined;
    healthInsuranceDueDate?: Date | undefined;
    withdrawWOWDbDate?: Date | undefined;
    withdrawWOWDate?: Date | undefined;
    withdrawWWDateDbDate?: Date | undefined;
    withdrawWWDate?: Date | undefined;
    gradePostDate?: Date | undefined;
    fullTimeUnitCode?: string | undefined;
    stopDate?: Date | undefined;
    orientationFeeCode?: string | undefined;
    week2BeginDate?: Date | undefined;
    week2EndDate?: Date | undefined;
    week2PercentPenalty?: number | undefined;
    week2FeeCode?: string | undefined;
    week3BeginDate?: Date | undefined;
    week3EndDate?: Date | undefined;
    week3PercentPenalty?: number | undefined;
    week3FeeCode?: string | undefined;
    orientationMandatory?: string | undefined;
    oissMandatory?: string | undefined;
    oissFeeCode?: string | undefined;
    rnrSessionOper?: string | undefined;
    trxPrintD?: string | undefined;
    burOper?: string | undefined;
    gradOrientationMandatory?: string | undefined;
    gradOrientationFeeCode?: string | undefined;
    finalExamBeginDbDate?: Date | undefined;
    finalExamBeginDate?: Date | undefined;
    finalExamEndDbDate?: Date | undefined;
    finalExamEndDate?: Date | undefined;
    f211?: string | undefined;
    insuranceMinimumUnits?: number | undefined;
    uscCampusCode?: string | undefined;
    midtermGradingBeginDate?: Date | undefined;
    midtermGradingEndDate?: Date | undefined;
    finalGradingBeginDate?: Date | undefined;
    finalGradingEndDate?: Date | undefined;
    contactName?: string | undefined;
    contactPhone?: string | undefined;
    break1BeginDbDate?: Date | undefined;
    break1BeginDate?: Date | undefined;
    break1EndDbDate?: Date | undefined;
    break1EndDate?: Date | undefined;
    break2BeginDbDate?: Date | undefined;
    break2BeginDate?: Date | undefined;
    break2EndDbDate?: Date | undefined;
    break2EndDate?: Date | undefined;
    summerTid?: string | undefined;
    lastEnrollmentOptionDbDate?: Date | undefined;
    lastEnrollmentOptionDate?: Date | undefined;
}

export class PeSection implements IPeSection {
    course?: PeCourse | undefined;
    session?: PeSession | undefined;
    sectionId?: number;
    courseId?: number;
    type!: string;
    sisSectionId!: string;
    termCode!: string;
    rnrSessionId?: number;
    name?: string | undefined;
    notes?: string | undefined;
    description?: string | undefined;
    tuitionUnitOverride?: number | undefined;
    dClearanceFlag?: string | undefined;
    rnrModeCode!: string;
    linkCode?: string | undefined;
    campusCode?: string | undefined;
    glObjectCode?: string | undefined;
    seats?: number | undefined;
    waitlistSize?: number | undefined;
    roomId?: number | undefined;
    cancelDate?: Date | undefined;
    overrideFlag?: string | undefined;
    manualDate?: Date | undefined;
    publishFlag?: string | undefined;
    publishSectionFlag?: string | undefined;
    addDate?: Date | undefined;
    blackboardFlag?: string | undefined;
    adastraDate?: Date | undefined;
    adastraOper?: string | undefined;
    adastraUpdateString?: string | undefined;
    ogssFlag?: string | undefined;
    ogRoleUpdatedFlag?: string | undefined;
    ogGradeUpdatedFlag?: string | undefined;
    grUpdateDate?: Date | undefined;
    apUpdateDate?: Date | undefined;
    ovUpdateDate?: Date | undefined;
    dlCode?: string | undefined;
    sGlAccountNumber?: string | undefined;
    sourceCode?: string | undefined;
    priorSisSectionId?: string | undefined;
    sectionMidtermBeginDate?: Date | undefined;
    sectionMidtermEndDate?: Date | undefined;
    sectionFinalBeginDate?: Date | undefined;
    sectionFinalEndDate?: Date | undefined;
    slackYn?: string | undefined;
    zoomYn?: string | undefined;
    gradObjective?: string | undefined;
    fdmPpgg?: string | undefined;
    fdmCostCenter?: string | undefined;
    fdmCompany?: string | undefined;
    fdmSpendRevenueUg?: string | undefined;
    fdmLedgerAccountUg?: string | undefined;
    fdmSpendRevenueG?: string | undefined;
    fdmLedgerAccountG?: string | undefined;
    numberRegistered?: number | undefined;
    spacesAvailable?: number | undefined;
    studentActiveWaiting?: number | undefined;

    constructor(data?: IPeSection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.course = _data["course"] ? PeCourse.fromJS(_data["course"]) : <any>undefined;
            this.session = _data["session"] ? PeSession.fromJS(_data["session"]) : <any>undefined;
            this.sectionId = _data["sectionId"];
            this.courseId = _data["courseId"];
            this.type = _data["type"];
            this.sisSectionId = _data["sisSectionId"];
            this.termCode = _data["termCode"];
            this.rnrSessionId = _data["rnrSessionId"];
            this.name = _data["name"];
            this.notes = _data["notes"];
            this.description = _data["description"];
            this.tuitionUnitOverride = _data["tuitionUnitOverride"];
            this.dClearanceFlag = _data["dClearanceFlag"];
            this.rnrModeCode = _data["rnrModeCode"];
            this.linkCode = _data["linkCode"];
            this.campusCode = _data["campusCode"];
            this.glObjectCode = _data["glObjectCode"];
            this.seats = _data["seats"];
            this.waitlistSize = _data["waitlistSize"];
            this.roomId = _data["roomId"];
            this.cancelDate = _data["cancelDate"] ? new Date(_data["cancelDate"].toString()) : <any>undefined;
            this.overrideFlag = _data["overrideFlag"];
            this.manualDate = _data["manualDate"] ? new Date(_data["manualDate"].toString()) : <any>undefined;
            this.publishFlag = _data["publishFlag"];
            this.publishSectionFlag = _data["publishSectionFlag"];
            this.addDate = _data["addDate"] ? new Date(_data["addDate"].toString()) : <any>undefined;
            this.blackboardFlag = _data["blackboardFlag"];
            this.adastraDate = _data["adastraDate"] ? new Date(_data["adastraDate"].toString()) : <any>undefined;
            this.adastraOper = _data["adastraOper"];
            this.adastraUpdateString = _data["adastraUpdateString"];
            this.ogssFlag = _data["ogssFlag"];
            this.ogRoleUpdatedFlag = _data["ogRoleUpdatedFlag"];
            this.ogGradeUpdatedFlag = _data["ogGradeUpdatedFlag"];
            this.grUpdateDate = _data["grUpdateDate"] ? new Date(_data["grUpdateDate"].toString()) : <any>undefined;
            this.apUpdateDate = _data["apUpdateDate"] ? new Date(_data["apUpdateDate"].toString()) : <any>undefined;
            this.ovUpdateDate = _data["ovUpdateDate"] ? new Date(_data["ovUpdateDate"].toString()) : <any>undefined;
            this.dlCode = _data["dlCode"];
            this.sGlAccountNumber = _data["sGlAccountNumber"];
            this.sourceCode = _data["sourceCode"];
            this.priorSisSectionId = _data["priorSisSectionId"];
            this.sectionMidtermBeginDate = _data["sectionMidtermBeginDate"] ? new Date(_data["sectionMidtermBeginDate"].toString()) : <any>undefined;
            this.sectionMidtermEndDate = _data["sectionMidtermEndDate"] ? new Date(_data["sectionMidtermEndDate"].toString()) : <any>undefined;
            this.sectionFinalBeginDate = _data["sectionFinalBeginDate"] ? new Date(_data["sectionFinalBeginDate"].toString()) : <any>undefined;
            this.sectionFinalEndDate = _data["sectionFinalEndDate"] ? new Date(_data["sectionFinalEndDate"].toString()) : <any>undefined;
            this.slackYn = _data["slackYn"];
            this.zoomYn = _data["zoomYn"];
            this.gradObjective = _data["gradObjective"];
            this.fdmPpgg = _data["fdmPpgg"];
            this.fdmCostCenter = _data["fdmCostCenter"];
            this.fdmCompany = _data["fdmCompany"];
            this.fdmSpendRevenueUg = _data["fdmSpendRevenueUg"];
            this.fdmLedgerAccountUg = _data["fdmLedgerAccountUg"];
            this.fdmSpendRevenueG = _data["fdmSpendRevenueG"];
            this.fdmLedgerAccountG = _data["fdmLedgerAccountG"];
            this.numberRegistered = _data["numberRegistered"];
            this.spacesAvailable = _data["spacesAvailable"];
            this.studentActiveWaiting = _data["studentActiveWaiting"];
        }
    }

    static fromJS(data: any): PeSection {
        data = typeof data === 'object' ? data : {};
        let result = new PeSection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["course"] = this.course ? this.course.toJSON() : <any>undefined;
        data["session"] = this.session ? this.session.toJSON() : <any>undefined;
        data["sectionId"] = this.sectionId;
        data["courseId"] = this.courseId;
        data["type"] = this.type;
        data["sisSectionId"] = this.sisSectionId;
        data["termCode"] = this.termCode;
        data["rnrSessionId"] = this.rnrSessionId;
        data["name"] = this.name;
        data["notes"] = this.notes;
        data["description"] = this.description;
        data["tuitionUnitOverride"] = this.tuitionUnitOverride;
        data["dClearanceFlag"] = this.dClearanceFlag;
        data["rnrModeCode"] = this.rnrModeCode;
        data["linkCode"] = this.linkCode;
        data["campusCode"] = this.campusCode;
        data["glObjectCode"] = this.glObjectCode;
        data["seats"] = this.seats;
        data["waitlistSize"] = this.waitlistSize;
        data["roomId"] = this.roomId;
        data["cancelDate"] = this.cancelDate ? this.cancelDate.toISOString() : <any>undefined;
        data["overrideFlag"] = this.overrideFlag;
        data["manualDate"] = this.manualDate ? this.manualDate.toISOString() : <any>undefined;
        data["publishFlag"] = this.publishFlag;
        data["publishSectionFlag"] = this.publishSectionFlag;
        data["addDate"] = this.addDate ? this.addDate.toISOString() : <any>undefined;
        data["blackboardFlag"] = this.blackboardFlag;
        data["adastraDate"] = this.adastraDate ? this.adastraDate.toISOString() : <any>undefined;
        data["adastraOper"] = this.adastraOper;
        data["adastraUpdateString"] = this.adastraUpdateString;
        data["ogssFlag"] = this.ogssFlag;
        data["ogRoleUpdatedFlag"] = this.ogRoleUpdatedFlag;
        data["ogGradeUpdatedFlag"] = this.ogGradeUpdatedFlag;
        data["grUpdateDate"] = this.grUpdateDate ? this.grUpdateDate.toISOString() : <any>undefined;
        data["apUpdateDate"] = this.apUpdateDate ? this.apUpdateDate.toISOString() : <any>undefined;
        data["ovUpdateDate"] = this.ovUpdateDate ? this.ovUpdateDate.toISOString() : <any>undefined;
        data["dlCode"] = this.dlCode;
        data["sGlAccountNumber"] = this.sGlAccountNumber;
        data["sourceCode"] = this.sourceCode;
        data["priorSisSectionId"] = this.priorSisSectionId;
        data["sectionMidtermBeginDate"] = this.sectionMidtermBeginDate ? this.sectionMidtermBeginDate.toISOString() : <any>undefined;
        data["sectionMidtermEndDate"] = this.sectionMidtermEndDate ? this.sectionMidtermEndDate.toISOString() : <any>undefined;
        data["sectionFinalBeginDate"] = this.sectionFinalBeginDate ? this.sectionFinalBeginDate.toISOString() : <any>undefined;
        data["sectionFinalEndDate"] = this.sectionFinalEndDate ? this.sectionFinalEndDate.toISOString() : <any>undefined;
        data["slackYn"] = this.slackYn;
        data["zoomYn"] = this.zoomYn;
        data["gradObjective"] = this.gradObjective;
        data["fdmPpgg"] = this.fdmPpgg;
        data["fdmCostCenter"] = this.fdmCostCenter;
        data["fdmCompany"] = this.fdmCompany;
        data["fdmSpendRevenueUg"] = this.fdmSpendRevenueUg;
        data["fdmLedgerAccountUg"] = this.fdmLedgerAccountUg;
        data["fdmSpendRevenueG"] = this.fdmSpendRevenueG;
        data["fdmLedgerAccountG"] = this.fdmLedgerAccountG;
        data["numberRegistered"] = this.numberRegistered;
        data["spacesAvailable"] = this.spacesAvailable;
        data["studentActiveWaiting"] = this.studentActiveWaiting;
        return data;
    }
}

export interface IPeSection {
    course?: PeCourse | undefined;
    session?: PeSession | undefined;
    sectionId?: number;
    courseId?: number;
    type: string;
    sisSectionId: string;
    termCode: string;
    rnrSessionId?: number;
    name?: string | undefined;
    notes?: string | undefined;
    description?: string | undefined;
    tuitionUnitOverride?: number | undefined;
    dClearanceFlag?: string | undefined;
    rnrModeCode: string;
    linkCode?: string | undefined;
    campusCode?: string | undefined;
    glObjectCode?: string | undefined;
    seats?: number | undefined;
    waitlistSize?: number | undefined;
    roomId?: number | undefined;
    cancelDate?: Date | undefined;
    overrideFlag?: string | undefined;
    manualDate?: Date | undefined;
    publishFlag?: string | undefined;
    publishSectionFlag?: string | undefined;
    addDate?: Date | undefined;
    blackboardFlag?: string | undefined;
    adastraDate?: Date | undefined;
    adastraOper?: string | undefined;
    adastraUpdateString?: string | undefined;
    ogssFlag?: string | undefined;
    ogRoleUpdatedFlag?: string | undefined;
    ogGradeUpdatedFlag?: string | undefined;
    grUpdateDate?: Date | undefined;
    apUpdateDate?: Date | undefined;
    ovUpdateDate?: Date | undefined;
    dlCode?: string | undefined;
    sGlAccountNumber?: string | undefined;
    sourceCode?: string | undefined;
    priorSisSectionId?: string | undefined;
    sectionMidtermBeginDate?: Date | undefined;
    sectionMidtermEndDate?: Date | undefined;
    sectionFinalBeginDate?: Date | undefined;
    sectionFinalEndDate?: Date | undefined;
    slackYn?: string | undefined;
    zoomYn?: string | undefined;
    gradObjective?: string | undefined;
    fdmPpgg?: string | undefined;
    fdmCostCenter?: string | undefined;
    fdmCompany?: string | undefined;
    fdmSpendRevenueUg?: string | undefined;
    fdmLedgerAccountUg?: string | undefined;
    fdmSpendRevenueG?: string | undefined;
    fdmLedgerAccountG?: string | undefined;
    numberRegistered?: number | undefined;
    spacesAvailable?: number | undefined;
    studentActiveWaiting?: number | undefined;
}

export class PeCourse implements IPeCourse {
    sections?: PeSection[] | undefined;
    courseId?: number;
    prefix?: string | undefined;
    classNumber?: string | undefined;
    sequence?: string | undefined;
    startTerm?: string | undefined;
    endTerm?: string | undefined;
    courseTitle?: string | undefined;
    description?: string | undefined;
    sisCatalogId!: string;
    suffix?: string | undefined;
    crossListedFlag?: string | undefined;
    publishedCourseId?: string | undefined;
    scheduledCourseId?: string | undefined;
    courseNotes?: string | undefined;
    departmentCode?: string | undefined;
    uscSchoolCode?: string | undefined;
    gradeType?: string | undefined;
    sexCode?: string | undefined;
    lastOfferedTermCode?: number | undefined;
    divFlag?: string | undefined;
    maxUnits?: string | undefined;

    constructor(data?: IPeCourse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["sections"])) {
                this.sections = [] as any;
                for (let item of _data["sections"])
                    this.sections!.push(PeSection.fromJS(item));
            }
            this.courseId = _data["courseId"];
            this.prefix = _data["prefix"];
            this.classNumber = _data["classNumber"];
            this.sequence = _data["sequence"];
            this.startTerm = _data["startTerm"];
            this.endTerm = _data["endTerm"];
            this.courseTitle = _data["courseTitle"];
            this.description = _data["description"];
            this.sisCatalogId = _data["sisCatalogId"];
            this.suffix = _data["suffix"];
            this.crossListedFlag = _data["crossListedFlag"];
            this.publishedCourseId = _data["publishedCourseId"];
            this.scheduledCourseId = _data["scheduledCourseId"];
            this.courseNotes = _data["courseNotes"];
            this.departmentCode = _data["departmentCode"];
            this.uscSchoolCode = _data["uscSchoolCode"];
            this.gradeType = _data["gradeType"];
            this.sexCode = _data["sexCode"];
            this.lastOfferedTermCode = _data["lastOfferedTermCode"];
            this.divFlag = _data["divFlag"];
            this.maxUnits = _data["maxUnits"];
        }
    }

    static fromJS(data: any): PeCourse {
        data = typeof data === 'object' ? data : {};
        let result = new PeCourse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sections)) {
            data["sections"] = [];
            for (let item of this.sections)
                data["sections"].push(item.toJSON());
        }
        data["courseId"] = this.courseId;
        data["prefix"] = this.prefix;
        data["classNumber"] = this.classNumber;
        data["sequence"] = this.sequence;
        data["startTerm"] = this.startTerm;
        data["endTerm"] = this.endTerm;
        data["courseTitle"] = this.courseTitle;
        data["description"] = this.description;
        data["sisCatalogId"] = this.sisCatalogId;
        data["suffix"] = this.suffix;
        data["crossListedFlag"] = this.crossListedFlag;
        data["publishedCourseId"] = this.publishedCourseId;
        data["scheduledCourseId"] = this.scheduledCourseId;
        data["courseNotes"] = this.courseNotes;
        data["departmentCode"] = this.departmentCode;
        data["uscSchoolCode"] = this.uscSchoolCode;
        data["gradeType"] = this.gradeType;
        data["sexCode"] = this.sexCode;
        data["lastOfferedTermCode"] = this.lastOfferedTermCode;
        data["divFlag"] = this.divFlag;
        data["maxUnits"] = this.maxUnits;
        return data;
    }
}

export interface IPeCourse {
    sections?: PeSection[] | undefined;
    courseId?: number;
    prefix?: string | undefined;
    classNumber?: string | undefined;
    sequence?: string | undefined;
    startTerm?: string | undefined;
    endTerm?: string | undefined;
    courseTitle?: string | undefined;
    description?: string | undefined;
    sisCatalogId: string;
    suffix?: string | undefined;
    crossListedFlag?: string | undefined;
    publishedCourseId?: string | undefined;
    scheduledCourseId?: string | undefined;
    courseNotes?: string | undefined;
    departmentCode?: string | undefined;
    uscSchoolCode?: string | undefined;
    gradeType?: string | undefined;
    sexCode?: string | undefined;
    lastOfferedTermCode?: number | undefined;
    divFlag?: string | undefined;
    maxUnits?: string | undefined;
}

export class PeSectionWr implements IPeSectionWr {
    courseWr?: PeCourseWr | undefined;
    session?: PeSession | undefined;
    sectionId?: number;
    courseId?: number;
    sisSectionId!: string;
    termCode!: string;
    rnrSessionId?: number;
    name?: string | undefined;
    notes?: string | undefined;
    description?: string | undefined;
    tuitionUnitOverride?: number | undefined;
    dClearanceFlag?: string | undefined;
    rnrModeCode!: string;
    rnrMode!: string;
    linkCode?: string | undefined;
    campusCode?: string | undefined;
    glObjectCode?: string | undefined;
    seats?: number | undefined;
    waitlistSize?: number | undefined;
    roomId?: number | undefined;
    cancelDate?: Date | undefined;
    overrideFlag?: string | undefined;
    manualDate?: Date | undefined;
    publishFlag?: string | undefined;
    publishSectionFlag?: string | undefined;
    addDate?: Date | undefined;
    addOper?: string | undefined;
    updatedDate?: Date | undefined;
    updatedOper?: string | undefined;
    blackboardFlag?: string | undefined;
    adastraDate?: Date | undefined;
    adastraOper?: string | undefined;
    adastraUpdateString?: string | undefined;
    ogssFlag?: string | undefined;
    ogRoleUpdatedFlag?: string | undefined;
    ogGradeUpdatedFlag?: string | undefined;
    grUpdateDate?: Date | undefined;
    apUpdateDate?: Date | undefined;
    ovUpdateDate?: Date | undefined;
    dlCode?: string | undefined;
    sGlAccountNumber?: string | undefined;
    sourceCode?: string | undefined;
    priorSisSectionId?: string | undefined;
    sectionMidtermBeginDate?: Date | undefined;
    sectionMidtermEndDate?: Date | undefined;
    sectionFinalBeginDate?: Date | undefined;
    sectionFinalEndDate?: Date | undefined;
    slackYn?: string | undefined;
    zoomYn?: string | undefined;
    numberRegistered?: number | undefined;
    spacesAvailable?: number | undefined;
    studentActiveWaiting?: number | undefined;
    sectionFeeId?: number | undefined;
    feeCode?: string | undefined;
    feeAmount?: number | undefined;
    dayCode?: string | undefined;
    startTime?: string | undefined;
    endTime?: string | undefined;
    location?: string | undefined;
    buildingCode?: string | undefined;
    roomNumber?: string | undefined;
    sectionLocationSqNumber?: number | undefined;
    rnrRoleCode?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    personName?: string | undefined;
    uscid?: string | undefined;
    eid?: string | undefined;
    legalLastName?: string | undefined;
    legalMiddleName?: string | undefined;
    legalFirstName?: string | undefined;
    preferredLastName?: string | undefined;
    preferredMiddleName?: string | undefined;
    preferredFirstName?: string | undefined;
    homeDepartmentCode?: string | undefined;
    homeDepartment?: string | undefined;
    employeeType?: string | undefined;
    employeeStatus?: string | undefined;
    workEmail?: string | undefined;
    workerType?: string | undefined;
    instructor?: string | undefined;
    sectionUnitId?: number | undefined;
    unitCode?: string | undefined;
    sectionUnitFeeId?: number | undefined;
    sectionUnitFeeCode?: string | undefined;
    sectionUnitFeeAmount?: number | undefined;
    sectionUnitPerUnit?: number | undefined;

    constructor(data?: IPeSectionWr) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseWr = _data["courseWr"] ? PeCourseWr.fromJS(_data["courseWr"]) : <any>undefined;
            this.session = _data["session"] ? PeSession.fromJS(_data["session"]) : <any>undefined;
            this.sectionId = _data["sectionId"];
            this.courseId = _data["courseId"];
            this.sisSectionId = _data["sisSectionId"];
            this.termCode = _data["termCode"];
            this.rnrSessionId = _data["rnrSessionId"];
            this.name = _data["name"];
            this.notes = _data["notes"];
            this.description = _data["description"];
            this.tuitionUnitOverride = _data["tuitionUnitOverride"];
            this.dClearanceFlag = _data["dClearanceFlag"];
            this.rnrModeCode = _data["rnrModeCode"];
            this.rnrMode = _data["rnrMode"];
            this.linkCode = _data["linkCode"];
            this.campusCode = _data["campusCode"];
            this.glObjectCode = _data["glObjectCode"];
            this.seats = _data["seats"];
            this.waitlistSize = _data["waitlistSize"];
            this.roomId = _data["roomId"];
            this.cancelDate = _data["cancelDate"] ? new Date(_data["cancelDate"].toString()) : <any>undefined;
            this.overrideFlag = _data["overrideFlag"];
            this.manualDate = _data["manualDate"] ? new Date(_data["manualDate"].toString()) : <any>undefined;
            this.publishFlag = _data["publishFlag"];
            this.publishSectionFlag = _data["publishSectionFlag"];
            this.addDate = _data["addDate"] ? new Date(_data["addDate"].toString()) : <any>undefined;
            this.addOper = _data["addOper"];
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.updatedOper = _data["updatedOper"];
            this.blackboardFlag = _data["blackboardFlag"];
            this.adastraDate = _data["adastraDate"] ? new Date(_data["adastraDate"].toString()) : <any>undefined;
            this.adastraOper = _data["adastraOper"];
            this.adastraUpdateString = _data["adastraUpdateString"];
            this.ogssFlag = _data["ogssFlag"];
            this.ogRoleUpdatedFlag = _data["ogRoleUpdatedFlag"];
            this.ogGradeUpdatedFlag = _data["ogGradeUpdatedFlag"];
            this.grUpdateDate = _data["grUpdateDate"] ? new Date(_data["grUpdateDate"].toString()) : <any>undefined;
            this.apUpdateDate = _data["apUpdateDate"] ? new Date(_data["apUpdateDate"].toString()) : <any>undefined;
            this.ovUpdateDate = _data["ovUpdateDate"] ? new Date(_data["ovUpdateDate"].toString()) : <any>undefined;
            this.dlCode = _data["dlCode"];
            this.sGlAccountNumber = _data["sGlAccountNumber"];
            this.sourceCode = _data["sourceCode"];
            this.priorSisSectionId = _data["priorSisSectionId"];
            this.sectionMidtermBeginDate = _data["sectionMidtermBeginDate"] ? new Date(_data["sectionMidtermBeginDate"].toString()) : <any>undefined;
            this.sectionMidtermEndDate = _data["sectionMidtermEndDate"] ? new Date(_data["sectionMidtermEndDate"].toString()) : <any>undefined;
            this.sectionFinalBeginDate = _data["sectionFinalBeginDate"] ? new Date(_data["sectionFinalBeginDate"].toString()) : <any>undefined;
            this.sectionFinalEndDate = _data["sectionFinalEndDate"] ? new Date(_data["sectionFinalEndDate"].toString()) : <any>undefined;
            this.slackYn = _data["slackYn"];
            this.zoomYn = _data["zoomYn"];
            this.numberRegistered = _data["numberRegistered"];
            this.spacesAvailable = _data["spacesAvailable"];
            this.studentActiveWaiting = _data["studentActiveWaiting"];
            this.sectionFeeId = _data["sectionFeeId"];
            this.feeCode = _data["feeCode"];
            this.feeAmount = _data["feeAmount"];
            this.dayCode = _data["dayCode"];
            this.startTime = _data["startTime"];
            this.endTime = _data["endTime"];
            this.location = _data["location"];
            this.buildingCode = _data["buildingCode"];
            this.roomNumber = _data["roomNumber"];
            this.sectionLocationSqNumber = _data["sectionLocationSqNumber"];
            this.rnrRoleCode = _data["rnrRoleCode"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.personName = _data["personName"];
            this.uscid = _data["uscid"];
            this.eid = _data["eid"];
            this.legalLastName = _data["legalLastName"];
            this.legalMiddleName = _data["legalMiddleName"];
            this.legalFirstName = _data["legalFirstName"];
            this.preferredLastName = _data["preferredLastName"];
            this.preferredMiddleName = _data["preferredMiddleName"];
            this.preferredFirstName = _data["preferredFirstName"];
            this.homeDepartmentCode = _data["homeDepartmentCode"];
            this.homeDepartment = _data["homeDepartment"];
            this.employeeType = _data["employeeType"];
            this.employeeStatus = _data["employeeStatus"];
            this.workEmail = _data["workEmail"];
            this.workerType = _data["workerType"];
            this.instructor = _data["instructor"];
            this.sectionUnitId = _data["sectionUnitId"];
            this.unitCode = _data["unitCode"];
            this.sectionUnitFeeId = _data["sectionUnitFeeId"];
            this.sectionUnitFeeCode = _data["sectionUnitFeeCode"];
            this.sectionUnitFeeAmount = _data["sectionUnitFeeAmount"];
            this.sectionUnitPerUnit = _data["sectionUnitPerUnit"];
        }
    }

    static fromJS(data: any): PeSectionWr {
        data = typeof data === 'object' ? data : {};
        let result = new PeSectionWr();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseWr"] = this.courseWr ? this.courseWr.toJSON() : <any>undefined;
        data["session"] = this.session ? this.session.toJSON() : <any>undefined;
        data["sectionId"] = this.sectionId;
        data["courseId"] = this.courseId;
        data["sisSectionId"] = this.sisSectionId;
        data["termCode"] = this.termCode;
        data["rnrSessionId"] = this.rnrSessionId;
        data["name"] = this.name;
        data["notes"] = this.notes;
        data["description"] = this.description;
        data["tuitionUnitOverride"] = this.tuitionUnitOverride;
        data["dClearanceFlag"] = this.dClearanceFlag;
        data["rnrModeCode"] = this.rnrModeCode;
        data["rnrMode"] = this.rnrMode;
        data["linkCode"] = this.linkCode;
        data["campusCode"] = this.campusCode;
        data["glObjectCode"] = this.glObjectCode;
        data["seats"] = this.seats;
        data["waitlistSize"] = this.waitlistSize;
        data["roomId"] = this.roomId;
        data["cancelDate"] = this.cancelDate ? this.cancelDate.toISOString() : <any>undefined;
        data["overrideFlag"] = this.overrideFlag;
        data["manualDate"] = this.manualDate ? this.manualDate.toISOString() : <any>undefined;
        data["publishFlag"] = this.publishFlag;
        data["publishSectionFlag"] = this.publishSectionFlag;
        data["addDate"] = this.addDate ? this.addDate.toISOString() : <any>undefined;
        data["addOper"] = this.addOper;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["updatedOper"] = this.updatedOper;
        data["blackboardFlag"] = this.blackboardFlag;
        data["adastraDate"] = this.adastraDate ? this.adastraDate.toISOString() : <any>undefined;
        data["adastraOper"] = this.adastraOper;
        data["adastraUpdateString"] = this.adastraUpdateString;
        data["ogssFlag"] = this.ogssFlag;
        data["ogRoleUpdatedFlag"] = this.ogRoleUpdatedFlag;
        data["ogGradeUpdatedFlag"] = this.ogGradeUpdatedFlag;
        data["grUpdateDate"] = this.grUpdateDate ? this.grUpdateDate.toISOString() : <any>undefined;
        data["apUpdateDate"] = this.apUpdateDate ? this.apUpdateDate.toISOString() : <any>undefined;
        data["ovUpdateDate"] = this.ovUpdateDate ? this.ovUpdateDate.toISOString() : <any>undefined;
        data["dlCode"] = this.dlCode;
        data["sGlAccountNumber"] = this.sGlAccountNumber;
        data["sourceCode"] = this.sourceCode;
        data["priorSisSectionId"] = this.priorSisSectionId;
        data["sectionMidtermBeginDate"] = this.sectionMidtermBeginDate ? this.sectionMidtermBeginDate.toISOString() : <any>undefined;
        data["sectionMidtermEndDate"] = this.sectionMidtermEndDate ? this.sectionMidtermEndDate.toISOString() : <any>undefined;
        data["sectionFinalBeginDate"] = this.sectionFinalBeginDate ? this.sectionFinalBeginDate.toISOString() : <any>undefined;
        data["sectionFinalEndDate"] = this.sectionFinalEndDate ? this.sectionFinalEndDate.toISOString() : <any>undefined;
        data["slackYn"] = this.slackYn;
        data["zoomYn"] = this.zoomYn;
        data["numberRegistered"] = this.numberRegistered;
        data["spacesAvailable"] = this.spacesAvailable;
        data["studentActiveWaiting"] = this.studentActiveWaiting;
        data["sectionFeeId"] = this.sectionFeeId;
        data["feeCode"] = this.feeCode;
        data["feeAmount"] = this.feeAmount;
        data["dayCode"] = this.dayCode;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        data["location"] = this.location;
        data["buildingCode"] = this.buildingCode;
        data["roomNumber"] = this.roomNumber;
        data["sectionLocationSqNumber"] = this.sectionLocationSqNumber;
        data["rnrRoleCode"] = this.rnrRoleCode;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["personName"] = this.personName;
        data["uscid"] = this.uscid;
        data["eid"] = this.eid;
        data["legalLastName"] = this.legalLastName;
        data["legalMiddleName"] = this.legalMiddleName;
        data["legalFirstName"] = this.legalFirstName;
        data["preferredLastName"] = this.preferredLastName;
        data["preferredMiddleName"] = this.preferredMiddleName;
        data["preferredFirstName"] = this.preferredFirstName;
        data["homeDepartmentCode"] = this.homeDepartmentCode;
        data["homeDepartment"] = this.homeDepartment;
        data["employeeType"] = this.employeeType;
        data["employeeStatus"] = this.employeeStatus;
        data["workEmail"] = this.workEmail;
        data["workerType"] = this.workerType;
        data["instructor"] = this.instructor;
        data["sectionUnitId"] = this.sectionUnitId;
        data["unitCode"] = this.unitCode;
        data["sectionUnitFeeId"] = this.sectionUnitFeeId;
        data["sectionUnitFeeCode"] = this.sectionUnitFeeCode;
        data["sectionUnitFeeAmount"] = this.sectionUnitFeeAmount;
        data["sectionUnitPerUnit"] = this.sectionUnitPerUnit;
        return data;
    }
}

export interface IPeSectionWr {
    courseWr?: PeCourseWr | undefined;
    session?: PeSession | undefined;
    sectionId?: number;
    courseId?: number;
    sisSectionId: string;
    termCode: string;
    rnrSessionId?: number;
    name?: string | undefined;
    notes?: string | undefined;
    description?: string | undefined;
    tuitionUnitOverride?: number | undefined;
    dClearanceFlag?: string | undefined;
    rnrModeCode: string;
    rnrMode: string;
    linkCode?: string | undefined;
    campusCode?: string | undefined;
    glObjectCode?: string | undefined;
    seats?: number | undefined;
    waitlistSize?: number | undefined;
    roomId?: number | undefined;
    cancelDate?: Date | undefined;
    overrideFlag?: string | undefined;
    manualDate?: Date | undefined;
    publishFlag?: string | undefined;
    publishSectionFlag?: string | undefined;
    addDate?: Date | undefined;
    addOper?: string | undefined;
    updatedDate?: Date | undefined;
    updatedOper?: string | undefined;
    blackboardFlag?: string | undefined;
    adastraDate?: Date | undefined;
    adastraOper?: string | undefined;
    adastraUpdateString?: string | undefined;
    ogssFlag?: string | undefined;
    ogRoleUpdatedFlag?: string | undefined;
    ogGradeUpdatedFlag?: string | undefined;
    grUpdateDate?: Date | undefined;
    apUpdateDate?: Date | undefined;
    ovUpdateDate?: Date | undefined;
    dlCode?: string | undefined;
    sGlAccountNumber?: string | undefined;
    sourceCode?: string | undefined;
    priorSisSectionId?: string | undefined;
    sectionMidtermBeginDate?: Date | undefined;
    sectionMidtermEndDate?: Date | undefined;
    sectionFinalBeginDate?: Date | undefined;
    sectionFinalEndDate?: Date | undefined;
    slackYn?: string | undefined;
    zoomYn?: string | undefined;
    numberRegistered?: number | undefined;
    spacesAvailable?: number | undefined;
    studentActiveWaiting?: number | undefined;
    sectionFeeId?: number | undefined;
    feeCode?: string | undefined;
    feeAmount?: number | undefined;
    dayCode?: string | undefined;
    startTime?: string | undefined;
    endTime?: string | undefined;
    location?: string | undefined;
    buildingCode?: string | undefined;
    roomNumber?: string | undefined;
    sectionLocationSqNumber?: number | undefined;
    rnrRoleCode?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    personName?: string | undefined;
    uscid?: string | undefined;
    eid?: string | undefined;
    legalLastName?: string | undefined;
    legalMiddleName?: string | undefined;
    legalFirstName?: string | undefined;
    preferredLastName?: string | undefined;
    preferredMiddleName?: string | undefined;
    preferredFirstName?: string | undefined;
    homeDepartmentCode?: string | undefined;
    homeDepartment?: string | undefined;
    employeeType?: string | undefined;
    employeeStatus?: string | undefined;
    workEmail?: string | undefined;
    workerType?: string | undefined;
    instructor?: string | undefined;
    sectionUnitId?: number | undefined;
    unitCode?: string | undefined;
    sectionUnitFeeId?: number | undefined;
    sectionUnitFeeCode?: string | undefined;
    sectionUnitFeeAmount?: number | undefined;
    sectionUnitPerUnit?: number | undefined;
}

export class PeCourseBase implements IPeCourseBase {
    courseId?: number;
    prefix?: string | undefined;
    courseTitle?: string | undefined;
    classNumber?: string | undefined;
    sequence?: string | undefined;
    suffix?: string | undefined;
    description?: string | undefined;
    courseNotes?: string | undefined;
    crossListedFlag?: string | undefined;

    constructor(data?: IPeCourseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseId = _data["courseId"];
            this.prefix = _data["prefix"];
            this.courseTitle = _data["courseTitle"];
            this.classNumber = _data["classNumber"];
            this.sequence = _data["sequence"];
            this.suffix = _data["suffix"];
            this.description = _data["description"];
            this.courseNotes = _data["courseNotes"];
            this.crossListedFlag = _data["crossListedFlag"];
        }
    }

    static fromJS(data: any): PeCourseBase {
        data = typeof data === 'object' ? data : {};
        let result = new PeCourseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseId"] = this.courseId;
        data["prefix"] = this.prefix;
        data["courseTitle"] = this.courseTitle;
        data["classNumber"] = this.classNumber;
        data["sequence"] = this.sequence;
        data["suffix"] = this.suffix;
        data["description"] = this.description;
        data["courseNotes"] = this.courseNotes;
        data["crossListedFlag"] = this.crossListedFlag;
        return data;
    }
}

export interface IPeCourseBase {
    courseId?: number;
    prefix?: string | undefined;
    courseTitle?: string | undefined;
    classNumber?: string | undefined;
    sequence?: string | undefined;
    suffix?: string | undefined;
    description?: string | undefined;
    courseNotes?: string | undefined;
    crossListedFlag?: string | undefined;
}

export class PeCourseWr extends PeCourseBase implements IPeCourseWr {
    sisCatalogId!: string;
    publishedCourseId?: string | undefined;
    scheduledCourseId?: string | undefined;
    departmentCode?: string | undefined;
    courseUscSchoolCode?: string | undefined;
    gradeType?: string | undefined;
    sexCode?: string | undefined;
    recommendedPrep?: string | undefined;
    duplicateCredit?: string | undefined;
    prerequisiteCourseCode?: string | undefined;
    classLevelCode?: string | undefined;
    classRestrictionType?: string | undefined;
    classIncludeExcludeCode?: string | undefined;
    postCode?: string | undefined;
    majorRestrictionType?: string | undefined;
    postIncludeExcludeCode?: string | undefined;
    uscSchoolCode?: string | undefined;
    schoolRestrictionType?: string | undefined;
    schoolIncludeExcludeCode?: string | undefined;
    courseUnit?: number | undefined;
    unitSisSqNumber?: number | undefined;
    courseGeneralEducationId?: number | undefined;
    generalEducationCode?: string | undefined;
    geSisSqNumber?: number | undefined;
    conferringUnitCode?: string | undefined;
    generalEducationDocCode?: string | undefined;
    rnrModeCode?: string | undefined;
    rnrModeHours?: string | undefined;

    constructor(data?: IPeCourseWr) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sisCatalogId = _data["sisCatalogId"];
            this.publishedCourseId = _data["publishedCourseId"];
            this.scheduledCourseId = _data["scheduledCourseId"];
            this.departmentCode = _data["departmentCode"];
            this.courseUscSchoolCode = _data["courseUscSchoolCode"];
            this.gradeType = _data["gradeType"];
            this.sexCode = _data["sexCode"];
            this.recommendedPrep = _data["recommendedPrep"];
            this.duplicateCredit = _data["duplicateCredit"];
            this.prerequisiteCourseCode = _data["prerequisiteCourseCode"];
            this.classLevelCode = _data["classLevelCode"];
            this.classRestrictionType = _data["classRestrictionType"];
            this.classIncludeExcludeCode = _data["classIncludeExcludeCode"];
            this.postCode = _data["postCode"];
            this.majorRestrictionType = _data["majorRestrictionType"];
            this.postIncludeExcludeCode = _data["postIncludeExcludeCode"];
            this.uscSchoolCode = _data["uscSchoolCode"];
            this.schoolRestrictionType = _data["schoolRestrictionType"];
            this.schoolIncludeExcludeCode = _data["schoolIncludeExcludeCode"];
            this.courseUnit = _data["courseUnit"];
            this.unitSisSqNumber = _data["unitSisSqNumber"];
            this.courseGeneralEducationId = _data["courseGeneralEducationId"];
            this.generalEducationCode = _data["generalEducationCode"];
            this.geSisSqNumber = _data["geSisSqNumber"];
            this.conferringUnitCode = _data["conferringUnitCode"];
            this.generalEducationDocCode = _data["generalEducationDocCode"];
            this.rnrModeCode = _data["rnrModeCode"];
            this.rnrModeHours = _data["rnrModeHours"];
        }
    }

    static override fromJS(data: any): PeCourseWr {
        data = typeof data === 'object' ? data : {};
        let result = new PeCourseWr();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sisCatalogId"] = this.sisCatalogId;
        data["publishedCourseId"] = this.publishedCourseId;
        data["scheduledCourseId"] = this.scheduledCourseId;
        data["departmentCode"] = this.departmentCode;
        data["courseUscSchoolCode"] = this.courseUscSchoolCode;
        data["gradeType"] = this.gradeType;
        data["sexCode"] = this.sexCode;
        data["recommendedPrep"] = this.recommendedPrep;
        data["duplicateCredit"] = this.duplicateCredit;
        data["prerequisiteCourseCode"] = this.prerequisiteCourseCode;
        data["classLevelCode"] = this.classLevelCode;
        data["classRestrictionType"] = this.classRestrictionType;
        data["classIncludeExcludeCode"] = this.classIncludeExcludeCode;
        data["postCode"] = this.postCode;
        data["majorRestrictionType"] = this.majorRestrictionType;
        data["postIncludeExcludeCode"] = this.postIncludeExcludeCode;
        data["uscSchoolCode"] = this.uscSchoolCode;
        data["schoolRestrictionType"] = this.schoolRestrictionType;
        data["schoolIncludeExcludeCode"] = this.schoolIncludeExcludeCode;
        data["courseUnit"] = this.courseUnit;
        data["unitSisSqNumber"] = this.unitSisSqNumber;
        data["courseGeneralEducationId"] = this.courseGeneralEducationId;
        data["generalEducationCode"] = this.generalEducationCode;
        data["geSisSqNumber"] = this.geSisSqNumber;
        data["conferringUnitCode"] = this.conferringUnitCode;
        data["generalEducationDocCode"] = this.generalEducationDocCode;
        data["rnrModeCode"] = this.rnrModeCode;
        data["rnrModeHours"] = this.rnrModeHours;
        super.toJSON(data);
        return data;
    }
}

export interface IPeCourseWr extends IPeCourseBase {
    sisCatalogId: string;
    publishedCourseId?: string | undefined;
    scheduledCourseId?: string | undefined;
    departmentCode?: string | undefined;
    courseUscSchoolCode?: string | undefined;
    gradeType?: string | undefined;
    sexCode?: string | undefined;
    recommendedPrep?: string | undefined;
    duplicateCredit?: string | undefined;
    prerequisiteCourseCode?: string | undefined;
    classLevelCode?: string | undefined;
    classRestrictionType?: string | undefined;
    classIncludeExcludeCode?: string | undefined;
    postCode?: string | undefined;
    majorRestrictionType?: string | undefined;
    postIncludeExcludeCode?: string | undefined;
    uscSchoolCode?: string | undefined;
    schoolRestrictionType?: string | undefined;
    schoolIncludeExcludeCode?: string | undefined;
    courseUnit?: number | undefined;
    unitSisSqNumber?: number | undefined;
    courseGeneralEducationId?: number | undefined;
    generalEducationCode?: string | undefined;
    geSisSqNumber?: number | undefined;
    conferringUnitCode?: string | undefined;
    generalEducationDocCode?: string | undefined;
    rnrModeCode?: string | undefined;
    rnrModeHours?: string | undefined;
}

export class SchoolVM extends BaseHierarchyItem implements ISchoolVM {
    programs?: ProgramVM[] | undefined;

    constructor(data?: ISchoolVM) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["programs"])) {
                this.programs = [] as any;
                for (let item of _data["programs"])
                    this.programs!.push(ProgramVM.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): SchoolVM {
        data = typeof data === 'object' ? data : {};
        let result = new SchoolVM();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.programs)) {
            data["programs"] = [];
            for (let item of this.programs)
                data["programs"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISchoolVM extends IBaseHierarchyItem {
    programs?: ProgramVM[] | undefined;
}

export class ProgramVM extends BaseHierarchyItem implements IProgramVM {
    schools?: SchoolVM[] | undefined;
    courses?: CourseVM[] | undefined;
    programNote?: string | undefined;
    departmentClearances?: DepartmentClearance[] | undefined;

    constructor(data?: IProgramVM) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["schools"])) {
                this.schools = [] as any;
                for (let item of _data["schools"])
                    this.schools!.push(SchoolVM.fromJS(item));
            }
            if (Array.isArray(_data["courses"])) {
                this.courses = [] as any;
                for (let item of _data["courses"])
                    this.courses!.push(CourseVM.fromJS(item));
            }
            this.programNote = _data["programNote"];
            if (Array.isArray(_data["departmentClearances"])) {
                this.departmentClearances = [] as any;
                for (let item of _data["departmentClearances"])
                    this.departmentClearances!.push(DepartmentClearance.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ProgramVM {
        data = typeof data === 'object' ? data : {};
        let result = new ProgramVM();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.schools)) {
            data["schools"] = [];
            for (let item of this.schools)
                data["schools"].push(item.toJSON());
        }
        if (Array.isArray(this.courses)) {
            data["courses"] = [];
            for (let item of this.courses)
                data["courses"].push(item.toJSON());
        }
        data["programNote"] = this.programNote;
        if (Array.isArray(this.departmentClearances)) {
            data["departmentClearances"] = [];
            for (let item of this.departmentClearances)
                data["departmentClearances"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IProgramVM extends IBaseHierarchyItem {
    schools?: SchoolVM[] | undefined;
    courses?: CourseVM[] | undefined;
    programNote?: string | undefined;
    departmentClearances?: DepartmentClearance[] | undefined;
}

export class DepartmentClearance implements IDepartmentClearance {
    prefix?: string | undefined;
    infoType?: string | undefined;
    buildingCode?: string | undefined;
    room?: string | undefined;
    phoneNumber?: string | undefined;
    uscEmail?: string | undefined;
    uscUrl?: string | undefined;

    constructor(data?: IDepartmentClearance) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prefix = _data["prefix"];
            this.infoType = _data["infoType"];
            this.buildingCode = _data["buildingCode"];
            this.room = _data["room"];
            this.phoneNumber = _data["phoneNumber"];
            this.uscEmail = _data["uscEmail"];
            this.uscUrl = _data["uscUrl"];
        }
    }

    static fromJS(data: any): DepartmentClearance {
        data = typeof data === 'object' ? data : {};
        let result = new DepartmentClearance();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prefix"] = this.prefix;
        data["infoType"] = this.infoType;
        data["buildingCode"] = this.buildingCode;
        data["room"] = this.room;
        data["phoneNumber"] = this.phoneNumber;
        data["uscEmail"] = this.uscEmail;
        data["uscUrl"] = this.uscUrl;
        return data;
    }
}

export interface IDepartmentClearance {
    prefix?: string | undefined;
    infoType?: string | undefined;
    buildingCode?: string | undefined;
    room?: string | undefined;
    phoneNumber?: string | undefined;
    uscEmail?: string | undefined;
    uscUrl?: string | undefined;
}

export class CoursePrefixVM extends BaseHierarchyItem implements ICoursePrefixVM {

    constructor(data?: ICoursePrefixVM) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): CoursePrefixVM {
        data = typeof data === 'object' ? data : {};
        let result = new CoursePrefixVM();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ICoursePrefixVM extends IBaseHierarchyItem {
}

export class PeConfigurableTermVM implements IPeConfigurableTermVM {
    termCode!: number;
    season!: TermSeason;
    year!: number;
    seasonName!: string;
    dateActive?: Date | undefined;

    constructor(data?: IPeConfigurableTermVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.termCode = _data["termCode"];
            this.season = _data["season"];
            this.year = _data["year"];
            this.seasonName = _data["seasonName"];
            this.dateActive = _data["dateActive"] ? new Date(_data["dateActive"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PeConfigurableTermVM {
        data = typeof data === 'object' ? data : {};
        let result = new PeConfigurableTermVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termCode"] = this.termCode;
        data["season"] = this.season;
        data["year"] = this.year;
        data["seasonName"] = this.seasonName;
        data["dateActive"] = this.dateActive ? this.dateActive.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPeConfigurableTermVM {
    termCode: number;
    season: TermSeason;
    year: number;
    seasonName: string;
    dateActive?: Date | undefined;
}

export class PeConfigurableSessionVM implements IPeConfigurableSessionVM {
    sessionCode!: string;
    termCode!: string;
    name!: string;

    constructor(data?: IPeConfigurableSessionVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionCode = _data["sessionCode"];
            this.termCode = _data["termCode"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): PeConfigurableSessionVM {
        data = typeof data === 'object' ? data : {};
        let result = new PeConfigurableSessionVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionCode"] = this.sessionCode;
        data["termCode"] = this.termCode;
        data["name"] = this.name;
        return data;
    }
}

export interface IPeConfigurableSessionVM {
    sessionCode: string;
    termCode: string;
    name: string;
}

export class GeCodeVm implements IGeCodeVm {
    geCode!: string;

    constructor(data?: IGeCodeVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.geCode = _data["geCode"];
        }
    }

    static fromJS(data: any): GeCodeVm {
        data = typeof data === 'object' ? data : {};
        let result = new GeCodeVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["geCode"] = this.geCode;
        return data;
    }
}

export interface IGeCodeVm {
    geCode: string;
}

export class SectionFeeVm implements ISectionFeeVm {
    sectionId!: number;
    fees?: SectionFee[] | undefined;

    constructor(data?: ISectionFeeVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sectionId = _data["sectionId"];
            if (Array.isArray(_data["fees"])) {
                this.fees = [] as any;
                for (let item of _data["fees"])
                    this.fees!.push(SectionFee.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SectionFeeVm {
        data = typeof data === 'object' ? data : {};
        let result = new SectionFeeVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sectionId"] = this.sectionId;
        if (Array.isArray(this.fees)) {
            data["fees"] = [];
            for (let item of this.fees)
                data["fees"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISectionFeeVm {
    sectionId: number;
    fees?: SectionFee[] | undefined;
}

export class SectionFee implements ISectionFee {
    amount?: string | undefined;
    description?: string | undefined;
    sisSqNumber?: number;

    constructor(data?: ISectionFee) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.description = _data["description"];
            this.sisSqNumber = _data["sisSqNumber"];
        }
    }

    static fromJS(data: any): SectionFee {
        data = typeof data === 'object' ? data : {};
        let result = new SectionFee();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["description"] = this.description;
        data["sisSqNumber"] = this.sisSqNumber;
        return data;
    }
}

export interface ISectionFee {
    amount?: string | undefined;
    description?: string | undefined;
    sisSqNumber?: number;
}

export class ProgramDetailsVM extends BaseHierarchyItem implements IProgramDetailsVM {
    programNote?: string | undefined;
    departmentClearances?: DepartmentClearance[] | undefined;

    constructor(data?: IProgramDetailsVM) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.programNote = _data["programNote"];
            if (Array.isArray(_data["departmentClearances"])) {
                this.departmentClearances = [] as any;
                for (let item of _data["departmentClearances"])
                    this.departmentClearances!.push(DepartmentClearance.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ProgramDetailsVM {
        data = typeof data === 'object' ? data : {};
        let result = new ProgramDetailsVM();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["programNote"] = this.programNote;
        if (Array.isArray(this.departmentClearances)) {
            data["departmentClearances"] = [];
            for (let item of this.departmentClearances)
                data["departmentClearances"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IProgramDetailsVM extends IBaseHierarchyItem {
    programNote?: string | undefined;
    departmentClearances?: DepartmentClearance[] | undefined;
}

export class SearchResultsVm implements ISearchResultsVm {
    termCode?: number;
    courseCount?: number;
    searchQuery?: string | undefined;
    courses?: CourseVM[] | undefined;
    programs?: ProgramVM[] | undefined;

    constructor(data?: ISearchResultsVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.termCode = _data["termCode"];
            this.courseCount = _data["courseCount"];
            this.searchQuery = _data["searchQuery"];
            if (Array.isArray(_data["courses"])) {
                this.courses = [] as any;
                for (let item of _data["courses"])
                    this.courses!.push(CourseVM.fromJS(item));
            }
            if (Array.isArray(_data["programs"])) {
                this.programs = [] as any;
                for (let item of _data["programs"])
                    this.programs!.push(ProgramVM.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchResultsVm {
        data = typeof data === 'object' ? data : {};
        let result = new SearchResultsVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termCode"] = this.termCode;
        data["courseCount"] = this.courseCount;
        data["searchQuery"] = this.searchQuery;
        if (Array.isArray(this.courses)) {
            data["courses"] = [];
            for (let item of this.courses)
                data["courses"].push(item.toJSON());
        }
        if (Array.isArray(this.programs)) {
            data["programs"] = [];
            for (let item of this.programs)
                data["programs"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISearchResultsVm {
    termCode?: number;
    courseCount?: number;
    searchQuery?: string | undefined;
    courses?: CourseVM[] | undefined;
    programs?: ProgramVM[] | undefined;
}

export class SimpleSyllabusCourseDto implements ISimpleSyllabusCourseDto {
    activeStatus?: string | undefined;
    term?: string | undefined;
    subject?: string | undefined;
    courseNumber?: string | undefined;
    courseTitle?: string | undefined;

    constructor(data?: ISimpleSyllabusCourseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activeStatus = _data["activeStatus"];
            this.term = _data["term"];
            this.subject = _data["subject"];
            this.courseNumber = _data["courseNumber"];
            this.courseTitle = _data["courseTitle"];
        }
    }

    static fromJS(data: any): SimpleSyllabusCourseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleSyllabusCourseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activeStatus"] = this.activeStatus;
        data["term"] = this.term;
        data["subject"] = this.subject;
        data["courseNumber"] = this.courseNumber;
        data["courseTitle"] = this.courseTitle;
        return data;
    }
}

export interface ISimpleSyllabusCourseDto {
    activeStatus?: string | undefined;
    term?: string | undefined;
    subject?: string | undefined;
    courseNumber?: string | undefined;
    courseTitle?: string | undefined;
}

export class SimpleSyllabusSectionDto implements ISimpleSyllabusSectionDto {
    activeStatus?: string | undefined;
    term?: string | undefined;
    subject?: string | undefined;
    courseNumber?: string | undefined;
    name?: string | undefined;
    sisSectionId?: string | undefined;

    constructor(data?: ISimpleSyllabusSectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activeStatus = _data["activeStatus"];
            this.term = _data["term"];
            this.subject = _data["subject"];
            this.courseNumber = _data["courseNumber"];
            this.name = _data["name"];
            this.sisSectionId = _data["sisSectionId"];
        }
    }

    static fromJS(data: any): SimpleSyllabusSectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleSyllabusSectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activeStatus"] = this.activeStatus;
        data["term"] = this.term;
        data["subject"] = this.subject;
        data["courseNumber"] = this.courseNumber;
        data["name"] = this.name;
        data["sisSectionId"] = this.sisSectionId;
        return data;
    }
}

export interface ISimpleSyllabusSectionDto {
    activeStatus?: string | undefined;
    term?: string | undefined;
    subject?: string | undefined;
    courseNumber?: string | undefined;
    name?: string | undefined;
    sisSectionId?: string | undefined;
}

export class SimpleSyllabusAccountsDto implements ISimpleSyllabusAccountsDto {
    activeStatus?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    sisId?: string | undefined;

    constructor(data?: ISimpleSyllabusAccountsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activeStatus = _data["activeStatus"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.sisId = _data["sisId"];
        }
    }

    static fromJS(data: any): SimpleSyllabusAccountsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleSyllabusAccountsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activeStatus"] = this.activeStatus;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["sisId"] = this.sisId;
        return data;
    }
}

export interface ISimpleSyllabusAccountsDto {
    activeStatus?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    sisId?: string | undefined;
}

export class SimpleSyllabusEnrollmentsDto implements ISimpleSyllabusEnrollmentsDto {
    activeStatus?: string | undefined;
    role?: string | undefined;
    accountSisId?: string | undefined;
    sectionSisId?: string | undefined;

    constructor(data?: ISimpleSyllabusEnrollmentsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activeStatus = _data["activeStatus"];
            this.role = _data["role"];
            this.accountSisId = _data["accountSisId"];
            this.sectionSisId = _data["sectionSisId"];
        }
    }

    static fromJS(data: any): SimpleSyllabusEnrollmentsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleSyllabusEnrollmentsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activeStatus"] = this.activeStatus;
        data["role"] = this.role;
        data["accountSisId"] = this.accountSisId;
        data["sectionSisId"] = this.sectionSisId;
        return data;
    }
}

export interface ISimpleSyllabusEnrollmentsDto {
    activeStatus?: string | undefined;
    role?: string | undefined;
    accountSisId?: string | undefined;
    sectionSisId?: string | undefined;
}

export class SimpleSyllabusDepartmentCoordinatorsDto implements ISimpleSyllabusDepartmentCoordinatorsDto {
    activeStatus?: string | undefined;
    role?: string | undefined;
    sisId?: string | undefined;
    prefix?: string | undefined;

    constructor(data?: ISimpleSyllabusDepartmentCoordinatorsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activeStatus = _data["activeStatus"];
            this.role = _data["role"];
            this.sisId = _data["sisId"];
            this.prefix = _data["prefix"];
        }
    }

    static fromJS(data: any): SimpleSyllabusDepartmentCoordinatorsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleSyllabusDepartmentCoordinatorsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activeStatus"] = this.activeStatus;
        data["role"] = this.role;
        data["sisId"] = this.sisId;
        data["prefix"] = this.prefix;
        return data;
    }
}

export interface ISimpleSyllabusDepartmentCoordinatorsDto {
    activeStatus?: string | undefined;
    role?: string | undefined;
    sisId?: string | undefined;
    prefix?: string | undefined;
}

export class TermAddVM implements ITermAddVM {
    season!: TermSeason;
    year!: number;
    dateActive!: Date;
    copiedFromTermCode?: number | undefined;

    constructor(data?: ITermAddVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.season = _data["season"];
            this.year = _data["year"];
            this.dateActive = _data["dateActive"] ? new Date(_data["dateActive"].toString()) : <any>undefined;
            this.copiedFromTermCode = _data["copiedFromTermCode"];
        }
    }

    static fromJS(data: any): TermAddVM {
        data = typeof data === 'object' ? data : {};
        let result = new TermAddVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["season"] = this.season;
        data["year"] = this.year;
        data["dateActive"] = this.dateActive ? this.dateActive.toISOString() : <any>undefined;
        data["copiedFromTermCode"] = this.copiedFromTermCode;
        return data;
    }
}

export interface ITermAddVM {
    season: TermSeason;
    year: number;
    dateActive: Date;
    copiedFromTermCode?: number | undefined;
}

export class TermCreateVM implements ITermCreateVM {
    season?: TermSeason;
    year?: number;
    lastDropDate?: Date;

    constructor(data?: ITermCreateVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.season = _data["season"];
            this.year = _data["year"];
            this.lastDropDate = _data["lastDropDate"] ? new Date(_data["lastDropDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TermCreateVM {
        data = typeof data === 'object' ? data : {};
        let result = new TermCreateVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["season"] = this.season;
        data["year"] = this.year;
        data["lastDropDate"] = this.lastDropDate ? this.lastDropDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ITermCreateVM {
    season?: TermSeason;
    year?: number;
    lastDropDate?: Date;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}